<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">
          <div class="settings-header">
            <span>
              Process Vendor Payment (Journal - Cash Disbursements) for Business Type: Service & Method of Accounting: Cash
            </span>
            <el-button size="mini" @click="() => $router.push(`/journal-and-gl?companyId=${$route.query.companyId}&tab=cashDisbursements`)">Journals</el-button>
          </div>
          <el-form
              label-position="left"
              ref="form"
              :model="form"
              :rules="rules"
              :disabled="disabledForm"
              class="form"
              size="mini">
            <el-card class="card">
              <div class="source-wrapper">
                <div class="source">
                  <h4 style="margin: 0px;">Source Document</h4>
                  <el-button type="primary" size="mini" @click="() => $refs.file.click()"><i class="el-icon-upload"></i>Source Documents</el-button>
                  <input :disabled="disabledForm" ref='file' v-show="false" @change="handleFilePreview" id="file" name="myFile" type="file">
                </div>
                <div @click="filesOpened = !filesOpened">
                  <i v-if="!filesOpened" class="el-icon-arrow-right tf-icon"></i>
                  <i v-else class="el-icon-arrow-down tf-icon"></i>
                </div>
              </div>
              <div v-if="filesOpened" style="margin-top: 40px; max-width: 50%;" class="source-content">
                <img v-if="imgPreviewSrc" style="width: 100%;" class="preview-banner" :src="imgPreviewSrc" alt="preview-banner">
              </div>
            </el-card>
            <el-card class="card">
              <h4 style="margin-top: 0px;">Vendor Details</h4>
              <el-row :span="24" :gutter="20">
                <el-col :span="6">
                  <el-form-item label-width="134px" prop="vendorId" label="Vendor">
                    <el-select
                        no-data-text="no date"
                        class="select"
                        placeholder="Type or Select Vendor (min 3 characters)"
                        v-model="form.vendorId"
                        @change="changeVendor"
                    >
                      <el-option
                          v-for="item in vendorList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="2">
                  <el-button
                      type="primary"
                      size="mini"
                      :disabled="disabledForm"
                      plain style="width: 100%"
                      @click="addVendorOpenModal">
                    + Add Vendor
                  </el-button>
                </el-col>
              </el-row>

              <!-- s -->
              <el-row :gutter="40">
                <el-col :span="8" :offset="0">
                  <el-form-item label-width="134px" prop="vendorTin" label="Vendor TIN">
                    <el-input v-model="form.vendorTin" readonly placeholder="Vendor TIN">
                    </el-input>
                  </el-form-item>

                  <el-form-item label-width="134px" prop="typeOfBusiness" label="Type of Business">
                    <el-input v-model="form.typeOfBusiness" readonly placeholder="Type of Business">
                    </el-input>
                  </el-form-item>

                  <el-form-item label-width="134px" prop="paymentTerms" label="Payment Terms">
                    <el-input v-model="form.paymentTerms" readonly placeholder="Payment Terms">
                    </el-input>
                  </el-form-item>

                  <el-form-item label-width="134px" prop="currency" label="Currency">
                    <span v-if="form.currency"> {{ form.currency }} </span>
                  </el-form-item>

                  <el-form-item label-width="200px" prop="veResult" label="Cash Advances To (Balance)">
                    <div style="display: flex; align-items: center; gap: 4px;">
                      <!-- <money
                        v-model="form.cashAdvancesToBalance"
                        disabled
                        :style="{ backgroundColor: '#F5F7FA'}"
                        @keydown.native="$event.key === '-' ? $event.preventDefault() : null"
                        v-bind="money">
                      </money>
                      <span style="color: red">Dr</span> -->
                      <money v-model="form.veResult" v-bind="money" :disabled="true" :style="{ backgroundColor: '#F5F7FA'}"></money><span style="color: red">Dr</span>
                    </div>
                  </el-form-item>

                </el-col>
                <el-col :span="8" :offset="0">
                  <el-form-item>
                    <span>Default Settings</span>
                    <span style="margin-left: 165px;">Override for this transaction</span>
                  </el-form-item>

                  <!-- <el-form-item label-width="130px" prop="isWHTax" label="Apply WHTax">
                    <el-checkbox v-model="form.isWHTax" disabled></el-checkbox>
                    <span class="checkbox__title" :class="{ 'checkbox__title_yes': this.form.isWHTax }">{{ form.isWHTax ? 'Yes' : 'No' }}</span>
                    <el-switch :disabled="!form.isWHTax" v-model="form.isWHTaxSwitch" @change="() => calculateResults()" style="margin-left: 20px;"></el-switch>
                  </el-form-item> -->

                  <el-form-item label-width="200px" prop="isWHTaxExpanded" label="Apply WHTax Expanded">
                    <el-checkbox v-model="form.isWHTaxExpanded" disabled></el-checkbox>
                    <span class="checkbox__title" :class="{ 'checkbox__title_yes': this.form.isWHTaxExpanded }">{{ form.isWHTaxExpanded ? 'Yes' : 'No' }}</span>
                    <el-switch :disabled="!form.isWHTaxExpanded" v-model="form.isWHTaxSwitch" @change="() => calculateResults()" style="margin-left: 20px;"></el-switch>
                    <!-- {{ !this.form.isWHTaxSwitch }} -->
                  </el-form-item>

                  <!-- <el-form-item label-width="130px" prop="isVatWHTax" label="Apply VAT WHTax">
                    <el-checkbox v-model="form.isVatWHTax" disabled></el-checkbox>
                    <span class="checkbox__title" :class="{ 'checkbox__title_yes': this.form.isVatWHTax }">{{ form.isVatWHTax ? 'Yes' : 'No' }}</span>
                    <el-switch :disabled="!form.isVatWHTax" v-model="form.isVatWHTaxSwitch" @change="() => calculateResults()" style="margin-left: 20px;"></el-switch>
                  </el-form-item> -->

                  <el-form-item label-width="200px" prop="isVatWHTaxExapnded" label="Apply Expanded WHT VAT">
                    <el-checkbox v-model="form.isVatWHTaxExapnded" disabled></el-checkbox>
                    <span class="checkbox__title" :class="{ 'checkbox__title_yes': this.form.isVatWHTaxExapnded }">{{ form.isVatWHTaxExapnded ? 'Yes' : 'No' }}</span>
                    <el-switch :disabled="!form.isVatWHTaxExapnded" v-model="form.isVatWHTaxSwitch" @change="() => calculateResults()" style="margin-left: 20px;"></el-switch>
                    <!-- {{ !this.form.isVatWHTaxSwitch }} -->
                  </el-form-item>

                  <el-form-item label-width="130px" prop="serviceVATCode" label="Service VAT Code">
                    <el-input v-model="form.serviceVATCode" readonly placeholder="Service VAT Code">
                    </el-input>
                  </el-form-item>

                  <el-form-item label-width="130px" prop="productVATCode" label="Product VAT Code">
                    <el-input v-model="form.productVATCode" readonly placeholder="Product VAT Code">
                    </el-input>
                  </el-form-item>

                </el-col>
              </el-row>
              <!-- e -->

              <!-- <el-row :span="24" :gutter="20">
                <el-col :span="4">
                  <el-form-item label-width="90px" prop="vendorTin" label="Vendor TIN">
                    <el-input v-model="form.vendorTin" readonly placeholder="Vendor TIN">
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="5" style="display: flex; justify-content: flex-end;">
                  <el-form-item label-width="200px" prop="isWHTaxExpanded" label="Apply WHTax Expanded">
                    <el-checkbox v-model="form.isWHTaxExpanded" disabled></el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <!-- <el-row :span="24" :gutter="20">
                <el-col :span="3">
                  <div>
                    <el-form-item
                        label-width="90px"
                        prop="currency"
                        label="Currency">
                      <span
                          v-if="form.currency"
                      >
                        {{form.currency }}
                      </span>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6" style="display: flex; justify-content: flex-end;">
                  <el-form-item label-width="200px" prop="isVatWHTaxExapnded" label="Apply Expanded WHT VAT">
                    <el-checkbox v-model="form.isVatWHTaxExapnded" disabled></el-checkbox>
                  </el-form-item>
                </el-col>
              </el-row> -->
              <!-- <el-row :span="24" :gutter="20">
                <el-col :span="5">
                  <el-form-item label-width="200px" prop="cashAdvancesToBalance" label="Cash Advances To (Balance)">
                    <money
                        v-model="form.cashAdvancesToBalance"
                        disabled
                        @keydown.native="$event.key === '-' ? $event.preventDefault() : null"
                        v-bind="money">
                    </money>
                  </el-form-item>
                </el-col>
              </el-row> -->

              <div style="max-width: 300px; position: absolute; top: 20px; right: 20px;">
                <el-row :span="24" :gutter="20">
                  <el-form-item label-width="150px" label="Transaction ID#">
                    <span class="transaction-no" @click="openJournalModal">
                      {{transactionNo}}
                    </span>
                  </el-form-item>
                  <el-form-item label-width="150px" prop="tranDate" label="Transaction Date">
                    <el-date-picker
                        style="width: 100%;"
                        v-model="form.tranDate"
                        :clearable='false'
                        format="d MMM yy"
                        value-format="MM-dd-yyyy"
                        type="date"
                        placeholder="Select Date"
                        @change="handleDateChange">
                    </el-date-picker>
                  </el-form-item>
                </el-row>
              </div>
            </el-card>
            <el-card v-if="form.vendorId" class="card card-2">
              <el-row :span="24" :gutter="20">
                <el-col :span="6">
                    <h4 style="margin-top: 0;">
                      Type of Expenditure
                      <el-tooltip content="Type of Expenditure" placement="top">
                        <i class="el-icon-warning warning-icon"></i>
                      </el-tooltip>
                    </h4>
                  <el-form-item prop="typeOfExpenditure">
                    <el-radio-group :value="form.typeOfExpenditure" class="radio-group-col">
                      <el-radio label="changeDirectToCost" @change="changeTypeOfExpenditureConfirm('changeDirectToCost')">Charge Direct to Cost or Expense Account</el-radio>
                      <el-form-item style="margin-left: 20px;" v-if="form.typeOfExpenditure === 'changeDirectToCost'" prop="typeOfSale">
                        <el-radio-group v-model="form.typeOfSale" class="radio-group-col" @change="changeTypeOfSale">
                          <el-radio label="isCostService">Cost of Service</el-radio>
                          <el-radio label="isExpense">Expense</el-radio>
                          <!--                      <el-radio label="isBuyingItems">Buying of Items</el-radio>-->
                          <el-radio label="isBoth">Both</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-radio label="isBuyingItems" @change="changeTypeOfExpenditureConfirm('isBuyingItems')">Buying of Items</el-radio>
                      <el-radio label="isBoth" @change="changeTypeOfExpenditureConfirm('isBoth')">Both</el-radio>
                    </el-radio-group>
<!--                    <el-select v-model="form.typeOfExpenditure" size="mini">-->
<!--                      <el-option v-for="item in typeOfExpenditureList"-->
<!--                                 :key="item.id"-->
<!--                                 :label="item.name"-->
<!--                                 :value="item.id">-->
<!--                      </el-option>-->
<!--                    </el-select>-->
                  </el-form-item>
                  <!-- <h4 style="margin-top: 0;">
                    Purchasing Currency
                  </h4>
                  <el-form-item label-width="0" prop="purchasingCurrency" style="max-width: 160px;">
                    <el-select
                        no-data-text="no date"
                        class="select"
                        disabled
                    >
                      <el-option
                          v-for="item in []"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item> -->
                </el-col>
                <el-col :span="5">
                  <h4 style="margin-top: 0;">
                    Purchasing Currency
                  </h4>
                  <span v-if="form.currency">
                    {{form.currency }}
                  </span>
                  <!-- <el-form-item label-width="0" prop="purchasingCurrency" style="max-width: 160px;">
                    <el-select
                        no-data-text="no date"
                        class="select"
                        v-model=""
                        disabled
                    >
                      <el-option
                          v-for="item in []"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item> -->
                </el-col>
                <el-col :span="5">
                  <h4 style="margin-top: 0;">Sales Tax</h4>
                  <el-form-item label-width="130px" prop="amountsAre" label="Amounts Are">
                    <el-select
                        no-data-text="no date"
                        class="select"
                        v-model="form.amountsAre"
                        @change="changeAmountsAre"
                    >
                      <el-option
                          v-for="item in taxList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" :style="{'display': 'flex', 'flex-direction': 'column', 'align-items': 'flex-end'}">
                  <el-form-item label-width="130px" label="Purchasing Notes" prop="purchasingNotes">
                    <el-input class="t-textarea" rows="4" cols="50" type="textarea" v-model="form.purchasingNotes"></el-input>
                  </el-form-item>
                  <!-- <div>
                    <div class="t-title">Sales Tax</div>
                    <el-form-item label-width="130px" prop="amountsAre" label="Amounts Are">
                      <el-select
                          no-data-text="no date"
                          class="select"
                          v-model="form.amountsAre"
                          @change="changeAmountsAre"
                      >
                        <el-option
                            v-for="item in taxList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div> -->
                </el-col>
              </el-row>
              <div :style="{ 'margin-top': '20px' }">
                <!-- <div style="font-size: 14px;">
                  {{
                    form.typeOfSale === 'isCostService'
                    ? 'Charge Direct to Cost of Service Account'
                    : form.typeOfSale === 'isExpense'
                    ? 'Charge Direct to Expense Account'
                    : 'Charges to Cost & Expense Accounts'
                  }}
                </div> -->
                <div v-if="this.form.typeOfExpenditure === 'changeDirectToCost'" style="display: flex; gap: 10px">
                  <el-tooltip :content="`${form.typeOfSale === 'isCostService' ? 'Charge Direct to Cost of Service Account' : form.typeOfSale === 'isExpense' ? 'Charge Direct to Expense Account' : 'Charges to Cost & Expense Accounts'}`" placement="top">
                    <i class="el-icon-warning warning-icon" style="margin-top: 6px;"></i>
                  </el-tooltip>
                  <el-form-item
                      :style="{ 'display': 'flex', 'align-items': 'center', 'max-width': '580px' }"
                      prop="generalSwitch"
                      :label="`${form.typeOfSale === 'isCostService' ? 'Charge Direct to Cost of Service Account' : form.typeOfSale === 'isExpense' ? 'Charge Direct to Expense Account' : 'Charges to Cost & Expense Accounts'}`">
                    <el-switch
                        class="t-switch"
                        v-model="form.generalSwitch">
                    </el-switch>
                  </el-form-item>
                </div>
                <div v-else style="display: flex; gap: 10px">
                  <el-tooltip :content="`${form.typeOfExpenditure === 'isBuyingItems' ? 'Buying of Items' : 'Charges to Cost & Expense Accounts'}`" placement="top">
                    <i class="el-icon-warning warning-icon" style="margin-top: 6px;"></i>
                  </el-tooltip>
                  <el-form-item
                      :style="{ 'display': 'flex', 'align-items': 'center', 'max-width': '580px' }"
                      prop="generalSwitch"
                      :label="`${form.typeOfExpenditure === 'isBuyingItems' ? 'Buying of Items' : 'Charges to Cost & Expense Accounts'}`">
                    <el-switch
                        class="t-switch"
                        v-model="form.generalSwitch">
                    </el-switch>
                  </el-form-item>
                </div>
                <CDServiceRevenueTable
                    v-if="form.generalSwitch"
                    ref="crServiceRevenue"
                    serviceRevenueKey="serviceRevenue"
                    :form="form"
                    :disabledForm="disabledForm"
                    :serviceRevenue="form.serviceRevenue"
                    :typeOfExpenditure="form.typeOfExpenditure"
                    :typeOfSale="form.typeOfSale"
                    :accountsRevenue="serviceRevenueAccountsList"
                    :units="units"
                    :lumpsumDiscountRates="lumpsumDiscountRates"
                    :salesTaxList="form.amountsAre === 4 ? salesTaxListTaxExemptTable : salesTaxList"
                    @calculateResults="calculateResults"
                    @addNewItem="addNewItem"
                    @removeItem="removeItem"
                />
              </div>
              <div :style="{ 'margin-top': '20px' }">
                <div style="display: flex; gap: 10px">
                  <el-tooltip content="Spending Direct to Other Expenditure Account" placement="top">
                    <i class="el-icon-warning warning-icon" style="margin-top: 6px;"></i>
                  </el-tooltip>
                  <el-form-item
                      :style="{ 'display': 'flex', 'align-items': 'center', 'max-width': '580px' }"
                      prop="salesDirectToMiscellaneous"
                      label="Spending Direct to Other Expenditure Account">
                    <el-switch
                        class="t-switch"
                        v-model="form.salesDirectToMiscellaneous">
                    </el-switch>
                  </el-form-item>
                </div>

                <CDServiceRevenueTable
                  v-if="form.salesDirectToMiscellaneous"
                  ref="crServiceRevenue2"
                  serviceRevenueKey="serviceRevenue2"
                  :form="form"
                  otherRevenue
                  :disabledForm="disabledForm"
                  :typeOfSale="form.typeOfSale"
                  :serviceRevenue="form.serviceRevenue2"
                  :accountsRevenue="accountsOtherExpenditures"
                  :units="units"
                  :lumpsumDiscountRates="lumpsumDiscountRates"
                  :salesTaxList="form.amountsAre === 4 ? salesTaxListTaxExemptTable : salesTaxList"
                  @calculateResults="calculateResults"
                  @addNewItem="addNewItem2"
                  @removeItem="removeItem2"
                />

                <div style="display: flex; gap: 10px">
                  <el-tooltip content="Charge Direct to Non Cost Account option" placement="top">
                    <i class="el-icon-warning warning-icon" style="margin-top: 6px;"></i>
                  </el-tooltip>
                  <el-form-item
                      :style="{ 'display': 'flex', 'align-items': 'center', 'max-width': '580px' }"
                      prop="chargeDirectToNonCostAccount"
                      label="Charge Direct to Non Cost Account option">
                    <el-switch
                        class="t-switch"
                        v-model="form.chargeDirectToNonCostAccount">
                    </el-switch>
                  </el-form-item>
                </div>

                <CDServiceRevenueTable
                    v-if="form.chargeDirectToNonCostAccount"
                    ref="cdNonCost"
                    serviceRevenueKey="nonCost"
                    :form="form"
                    otherRevenue
                    :disabledForm="disabledForm"
                    :typeOfSale="form.typeOfSale"
                    :serviceRevenue="form.nonCost"
                    :accountsRevenue="accountsAll"
                    :units="units"
                    :lumpsumDiscountRates="lumpsumDiscountRates"
                    :salesTaxList="form.amountsAre === 4 ? salesTaxListTaxExemptTable : salesTaxList"
                    @calculateResults="calculateResults"
                    @addNewItem="addNewItem3"
                    @removeItem="removeItem3"
                />
              </div>

              <div :style="{ 'margin-top': '20px', fontWeight: 'bold' }" v-if="form.typeOfExpenditure === 'isBoth'">
                <div style="font-size: 14px;">Sales of Service Items</div>
                <CDServiceRevenueTable
                  ref="cdSalesServiceItems"
                  serviceRevenueKey="salesServiceItems"
                  :form="form"
                  :disabledForm="disabledForm"
                  :serviceRevenue="form.salesServiceItems"
                  :accountsRevenue="accountsRevenueSales"
                  :units="units"
                  :lumpsumDiscountRates="lumpsumDiscountRates"
                  :salesTaxList="form.amountsAre === 4 ? salesTaxListTaxExemptTable : salesTaxList"
                  @calculateResults="calculateResults"
                  @addNewItem="addNewItem4"
                  @removeItem="removeItem4"
                />
              </div>
            </el-card>
            <div style="display:flex; gap: 20px;">
              <el-card class="card" style="width:100%;">
                <h4 style="margin-top: 0px;">
                  <el-tooltip content="Payment Details" placement="top">
                    <i class="el-icon-warning warning-icon"></i>
                  </el-tooltip>
                  Payment Details
                </h4>
                <el-row :span="24" :gutter="20">
                  <el-col :span="9">
                    <el-form-item prop="veResult" label="Cash Advances To (Balance)">
                      <div style="display: flex; align-items: center; gap: 4px;">
                        <!-- <money
                          v-model="form.cashAdvancesToBalanceDetails"
                          disabled
                          @keydown.native="$event.key === '-' ? $event.preventDefault() : null"
                          v-bind="money">
                        </money> -->
                        <money v-model="form.veResult" v-bind="money" :disabled="true" :style="{ backgroundColor: '#F5F7FA'}"></money><span style="color: red">Dr</span>
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-button :disabled="!this.form.vendorId" type="primary" size="mini" @click="useBalance">Use Balance</el-button>
                    <!-- <el-form-item  label="Use Balance">
                      <el-switch
                        v-model="form.isUseBalance"
                        :disabled="form.cashAdvancesToBalance < 0"
                        @change="() => {
                          if (!form.isUseBalance) {
                            form.appliedUnderOverPMTBal = 0
                          }
                          calculateResults()
                        }"></el-switch>
                    </el-form-item> -->
                  </el-col>
                  <el-col :span="9">
                    <el-form-item
                        label-width="150px"
                        prop="appliedUnderOverPMTBal"
                        label="Amount Applied">
                      <!-- <money
                          v-model="form.appliedUnderOverPMTBal"
                          v-bind="money"
                          :disabled="!form.isUseBalance"
                          :style="{ backgroundColor: !form.isUseBalance ? '#F5F7FA' : 'transparent' }"
                          @input.native="appliedUnderOverPMTChange"></money> -->
                      <money
                          v-model="form.appliedUnderOverPMTBal"
                          v-bind="money"
                          :disabled="true"
                          :style="{ backgroundColor: true ? '#F5F7FA' : 'transparent' }"></money>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- <el-row :span="24" :gutter="20">
                  <el-col :span="4">
                    <el-form-item prop="actionsToDo" label="Mode of Payment" style="max-width:200px;">
                      <el-select
                          no-data-text="no date"
                          class="select"
                          v-model="form.modeOfPayment"
                          @change="calculateResults"
                      >
                        <el-option
                            v-for="item in modeOfPaymentList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="5">
                    <el-form-item prop="paymentCurrency" label="Payment Currency" style="max-width:200px;">
                      <el-select
                          no-data-text="no date"
                          class="select"
                          v-model="form.paymentCurrency"
                          @change="() => calculateResults()"
                      >
                        <el-option
                            v-for="item in paymentCurrencyList"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item
                        v-if="form.currency && form.currency !== companyLayout.currency.code"
                        style="margin-left: 20px;"
                        prop="exchangeRate"
                        label="Rate">
                      <el-input v-model="form.exchangeRate" type="number" placeholder="Rate" @input="() => calculateResults()"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item label="Paid By" prop="paidBy">
                      <el-select
                          no-data-text="no date"
                          placeholder="Paid By"
                          class="select"
                          v-model="form.paidBy"
                      >
                        <el-option
                            v-for="item in paidByListChanged"
                            :key="item.id"
                            :label="item.fullName"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4">
                    <el-form-item prop="forUser" label="For User">
                      <el-select
                          no-data-text="no date"
                          placeholder="For User"
                          class="select"
                          v-model="form.forUser"
                      >
                        <el-option
                            v-for="item in forUserList"
                            :key="item.id"
                            :label="item.fullName"
                            :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row> -->

                <!-- <SinglePaymentMethodCD
                    v-if="form.modeOfPayment === 1"
                    ref="singlePM"
                    :disabledForm="disabledForm"
                    :paymentMethodList="paymentMethodList"
                    :paidByList="forUserList"
                    @calculateResults="calculateResults"
                /> -->
                <!-- <SplitsPaymentsMethodCD
                    v-if="form.modeOfPayment === 2"
                    ref="splitPM"
                    :disabledForm="disabledForm"
                    :paymentMethodList="paymentMethodList"
                    :paidByList="forUserList"
                    @calculateResults="calculateResults"
                /> -->

                <div style="display: flex; flex-direction: row; gap: 20px;">
                  <div>
                    <el-form-item
                        label-width="140px"
                        label="Paid Date *"
                        prop="paidDate">
                      <el-date-picker
                          style="width: 100%"
                          v-model="form.paidDate"
                          :clearable='false'
                          format="d MMM yy"
                          value-format="MM-dd-yyyy"
                          type="date"
                          placeholder="Select Date">
                      </el-date-picker>
                    </el-form-item>

                    <el-form-item prop="paymentCurrency" label-width="140px" label="Payment Currency *">
                      <el-select
                        no-data-text="no date"
                        v-model="form.paymentCurrency"
                        @change="() => calculateResults()">
                        <el-option
                          v-for="item in paymentCurrencyList"
                          :key="item"
                          :label="item"
                          :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item
                      v-if="form.currency && form.currency !== companyLayout.currency.code"
                      prop="exchangeRate"
                      label-width="140px"
                      label="Rate">
                      <el-input v-model="form.exchangeRate" type="number" placeholder="Rate" @input="() => calculateResults()"></el-input>
                    </el-form-item>

                    <el-form-item label-width="140px" label="Paid By *" prop="paidBy">
                      <el-select
                        no-data-text="no date"
                        placeholder="Paid By"
                        v-model="form.paidBy">
                        <el-option
                          v-for="item in paidByListChanged"
                          :key="item.id"
                          :label="item.fullName"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item prop="forUser" label-width="140px" label="For User *">
                      <el-select
                        no-data-text="no date"
                        placeholder="For User"
                        v-model="form.forUser">
                        <el-option
                          v-for="item in forUserList"
                          :key="item.id"
                          :label="item.fullName"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item prop="actionsToDo" label-width="140px" label="Mode of Payment">
                      <el-select
                        no-data-text="no date"
                        class="select"
                        v-model="form.modeOfPayment"
                        @change="calculateResults">
                        <el-option
                          v-for="item in modeOfPaymentList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div v-if="form.modeOfPayment === 1" style="flex: 1;">
                    <SinglePaymentMethodCD
                      v-if="form.modeOfPayment === 1"
                      ref="singlePM"
                      :disabledForm="disabledForm"
                      :paymentMethodList="paymentMethodList"
                      :paidByList="forUserList"
                      @calculateResults="calculateResults"
                    />
                  </div>
                  <SplitsPaymentsMethodCD
                    v-if="form.modeOfPayment === 2"
                    ref="splitPM"
                    :disabledForm="disabledForm"
                    :paymentMethodList="paymentMethodList"
                    :paidByList="forUserList"
                    @calculateResults="calculateResults"
                  />
                </div>

                <el-form-item label-position="top" label="Payment For" prop="paymentFor">
                  <el-input class="t-textarea" rows="4" cols="50" type="textarea" v-model="form.paymentFor"></el-input>
                </el-form-item>
              </el-card>
              <el-card class="card" style="min-width: 710px;">
                <h4 style="margin-top: 0px;">Transaction Summary</h4>
                <cash-receipt-result-no-tax-c-d
                    v-if="form.amountsAre === 1"
                    :appliedUnderOverPMTBal="form.appliedUnderOverPMTBal"
                    :otherExpendituresCharges="results.otherExpendituresCharges"
                    :nonCostCharges="results.nonCostCharges"
                    :discount="results.discount"
                    :vatableAmount="results.vatableAmount"
                    :vatExAmount="results.vatExAmount"
                    :zeroRatedAmount="results.zeroRatedAmount"
                    :vatAmount="results.vatAmount"
                    :totalAmount="results.totalAmount"
                    :currency="form.currency"
                    :amountOwingClientCurrency="results.amountOwingVendorCurrency"
                    :receivedAmountClientCurrency="results.receivedAmountVendorCurrency"
                    :balanceOwingClientCurrency="results.balanceOwingVendorCurrency"
                    :amountVatExcluded="results.amountVatExcluded"
                    :lessWHTaxExpanded="results.lessWHTaxExpanded"
                    :amountOwing="results.amountOwing"
                    :receivedAmount="results.receivedAmount"
                    :balanceOwing="results.balanceOwing"
                    :overPayment="results.overPayment"
                    :underPayment="results.underPayment"
                    :addVatAmount="results.addVatAmount"
                    :totalAmountVatInclusinve="results.totalAmountVatInclusinve"
                    :totalAmountNoTax="results.totalAmountNoTax"
                    :lessCreditableWithholdingTax="results.lessCreditableWithholdingTax"
                    :underPaymentClientCurrency="results.underPaymentVendorCurrency"
                    :overPaymentClientCurrency="results.overPaymentVendorCurrency"
                    :transaction="transaction"
                    :transactionNo="transactionNo"
                />
                <cash-receipt-result-tax-exempt-c-d
                    v-else
                    :appliedUnderOverPMTBal="form.appliedUnderOverPMTBal"
                    :otherExpendituresCharges="results.otherExpendituresCharges"
                    :nonCostCharges="results.nonCostCharges"
                    :discount="results.discount"
                    :vatableAmount="results.vatableAmount"
                    :vatExAmount="results.vatExAmount"
                    :zeroRatedAmount="results.zeroRatedAmount"
                    :vatAmount="results.vatAmount"
                    :totalAmount="results.totalAmount"
                    :currency="form.currency"
                    :amountOwingClientCurrency="results.amountOwingVendorCurrency"
                    :receivedAmountClientCurrency="results.receivedAmountVendorCurrency"
                    :balanceOwingClientCurrency="results.balanceOwingVendorCurrency"
                    :amountVatExcluded="results.amountVatExcluded"
                    :lessWHTaxExpanded="results.lessWHTaxExpanded"
                    :amountOwing="results.amountOwing"
                    :receivedAmount="results.receivedAmount"
                    :balanceOwing="results.balanceOwing"
                    :overPayment="results.overPayment"
                    :underPayment="results.underPayment"
                    :addVatAmount="results.addVatAmount"
                    :totalAmountVatInclusinve="results.totalAmountVatInclusinve"
                    :totalAmountNoTax="results.totalAmountNoTax"
                    :lessCreditableWithholdingVat="results.lessCreditableWithholdingVat"
                    :lessCreditableWithholdingTax="results.lessCreditableWithholdingTax"
                    :underPaymentClientCurrency="results.underPaymentVendorCurrency"
                    :overPaymentClientCurrency="results.overPaymentVendorCurrency"
                    :transaction="transaction"
                    :transactionNo="transactionNo"
                />
              </el-card>
            </div>
          </el-form>
          <div class="actions" :span="24" :gutter="20" style="display: flex; justify-content: space-between; align-items: flex-end; margin-top: 20px;">
            <div>
              <div style="margin-bottom: 10px;">
                Created By:
                <span v-if="!$route.params.id && user && user.user"> <b>{{user.user.firstname}} {{user.user.lastname}}</b></span>
                <span v-else> <b>{{form.createByFullName}}</b></span>
              </div>
              <div class="actions__wrapper">
                <el-button v-if="companyLayout.permission.historyAccountThinkCashDisbursement" :disabled="!$route.params.id" type="primary" size="mini" @click="openModalHistory">History</el-button>
                <el-button v-if="(!isBlock || (isBlock && companyLayout.permission.makeTransactionAdjustmentsInLockedPeriod)) && companyLayout.permission.reverseAccountThinkCashDisbursement" :disabled="status != 'Post'" size="mini" @click="reverse($route.params.id)">Reverse</el-button>
              </div>
            </div>
            <div v-if="!isBlock || (isBlock && companyLayout.permission.makeTransactionAdjustmentsInLockedPeriod)">
              <div class="actions__wrapper">
                <el-button v-if="companyLayout.permission.addAccountThinkCashDisbursement" :disabled="!!$route.params.id" type="primary" size="mini" @click="add(false)">Add</el-button>
                <el-button v-if="companyLayout.permission.addAccountThinkCashDisbursement" :disabled="!!$route.params.id" type="primary" size="mini" @click="addAndNew(false)">Add and new</el-button>
                <el-button :disabled="!!$route.params.id" type="primary" size="mini">Cheque Voucher (CV)</el-button>
                <el-button v-if="(disabledForm && !updatedState) && companyLayout.permission.editAccountThinkCashDisbursement" :disabled="isDisabledEdit" size="mini" @click="() => {
                    updatedState = true
                    disabledForm = false
                  }">Edit</el-button>
                <el-button v-else-if="updatedState" size="mini" @click="add($route.params.id)" :disabled="isDisabledEdit">Save Changes</el-button>
                <el-button v-if="companyLayout.permission.checkedAccountThinkCashDisbursement" :disabled="status != 'Add'" size="mini" @click="checked($route.params.id)">Checked</el-button>
                <el-button v-if="companyLayout.permission.sendToAccountantAccountThinkCashDisbursement" :disabled="status != 'Check'" size="mini" @click="sendToAccountant($route.params.id)">Send to Accountant</el-button>
                <el-button v-if="(status === 'Post') && companyLayout.permission.voidAccountThinkCashDisbursement" :disabled="status === 'Void' || status === 'Reverse'" size="mini" @click="voidCashDisbursement($route.params.id)">Void</el-button>
                <el-button v-if="(status !== 'Post') && companyLayout.permission.deleteAccountThinkCashDisbursement" :disabled="status === 'Void' || status === 'Reverse' || !status" size="mini" @click="deleteCashDisbursement($route.params.id)">Delete</el-button>
                <el-button v-if="companyLayout.permission.recordAccountThinkCashDisbursement" :disabled="status != 'Check'" size="mini" @click="record($route.params.id)">Record</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-history :historyList='historyList' ref="openHistory"></modal-history>
    <add-vendor-form ref="modal11" :directories="vendorDirectories" @selected="selectVendor" />
    <CashDisbursementsJournalModal ref="cashDisbursementstModal" />
    <editJournalEntryModal :showInfo="false" ref="editJournalEntryModal"/>
    <CDUseBalance
      :amountOwing="results.amountOwing"
      :totalAmountVatInclusinve="results.totalAmountVatInclusinve"
      :tableData="listCDForUseBalance"
      @overPMTBal="initAppliedUnderOverPMTBal"
      ref="CDUseBalance"/>
  </div>
</template>

<script>
import axios from 'axios'
import { Money } from 'v-money'
import SplitsPaymentsMethodCD from "@/components/cashReceipts/SplitsPaymentsMethodCD.vue";
import SinglePaymentMethodCD from "@/components/cashReceipts/SinglePaymentMethodCD.vue";
import CashReceiptResultNoTaxCD from "@/components/cashReceipts/results/CashReceiptResultNoTaxCD.vue";
import CashReceiptResultTaxExemptCD from "@/components/cashReceipts/results/CashReceiptResultTaxExemptCD.vue";
import CDServiceRevenueTable from "@/components/cashReceipts/tables/CDServiceRevenueTable.vue";
import moment from "moment";
import ModalHistory from "@/components/journalAndGl/historyJournalEntry.vue";
import AddVendorForm from '@/components/vendors/AddVendorForm2.vue'
import CashDisbursementsJournalModal from '@/layout/components/yourOrganization/CashDisbursementsJournalModal.vue'
import CDUseBalance from "@/components/cashReceipts/tables/CDUseBalance.vue";
const FASTFOREX_API_KEY = process.env.VUE_APP_FASTFOREX_API_KEY
import editJournalEntryModal from '@/components/journalAndGl/editJournalEntryModal.vue'

export default {
  name: "CashDisbursements",
  components: {
    AddVendorForm,
    ModalHistory,
    CDServiceRevenueTable,
    CashReceiptResultTaxExemptCD,
    CashReceiptResultNoTaxCD,
    SinglePaymentMethodCD,
    SplitsPaymentsMethodCD,
    Money,
    CashDisbursementsJournalModal,
    CDUseBalance,
    editJournalEntryModal,
  },
  data: vm => vm.initialData(),
  computed: {
    user() {
      return this.$store.state.user
    },
    companyLayout() {
      return this.$store.state.companyLayout
    },
    isAccountant() {
      return this.companyLayout.userRights.isAccountant
    },
    addedBy() {
      return this.user.user ? this.user.user.id : null
    },
    paidByListChanged() {
      return this.forUserList.filter(val => val.isChequeReceipts)
    },
    selectedVendor() {
      if (this.form.vendorId) {
        const vendor = this.vendorList.find(vendor => vendor.id === this.form.vendorId)
        return vendor ? vendor : null
      }
      return null
    },
    salesTaxListExemptTax() {
      return this.salesTaxList.find(tax => tax.exemptTax)
    },
    salesTaxListNoTaxSP() {
      return this.salesTaxList.find(tax => tax.noTaxSP)
    },
    salesTaxListNoTax() {
      return this.salesTaxList.find(tax => tax.noTax)
    },
    salesTaxListWithZeroRate() {
      return this.salesTaxList.find(tax => tax.zeroTax)
    },
    salesTaxListTaxExemptTable() {
      return [this.salesTaxListWithZeroRate, this.salesTaxListExemptTax]
    },
    paymentCurrencyList() {
      const currencies = []
      if (this.companyLayout.currency) {
        currencies.push(this.companyLayout.currency.code)
      }
      if (this.form.currency) {
        currencies.push(this.form.currency)
      }
      return [...new Set(currencies)]
    },
    serviceRevenueAccountsList() {
      switch(this.form.typeOfExpenditure) {
        case 'changeDirectToCost':
          if (this.form.typeOfSale === 'isCostService') {
            return this.accountsCostOFService
          }
          if (this.form.typeOfSale === 'isExpense') {
            return this.accountsExpenses
          }
          if (this.form.typeOfSale === 'isBoth') {
            return [{ label: 'Cost of Service', options: this.accountsCostOFService }, { label: 'Expense', options: this.accountsExpenses }]
          }
      }
      return this.accountsRevenue
    },
    isDisabledEdit() {
      if (this.status === 'Post' || this.status === 'Void') {
        return true
      }
      if (this.isSendToAcc && this.isAccountant) {
        return false
      }
      if (!this.isSendToAcc) {
        return false
      }
      return true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    handleDateChange(value) {
      // if (!this.companyLayout.lockAccountingPeriodTo) {
      //   this.$message.error("Set Lock Accounting Period")
      //   this.form.tranDate = null
      //   return
      // }

      if (this.companyLayout.lockAccountingPeriodTo) {
        const baseDate = new Date(this.companyLayout.lockAccountingPeriodTo)
        baseDate.setHours(0, 0, 0, 0)

        const [month, day, year] = value.split('-').map(Number)
        const selectedDate = new Date(year, month - 1, day)

        if (selectedDate.getTime() <= baseDate.getTime()) {
          this.$message.error("This is a locked period; you cannot create, edit, or modify transactions during this period.")
          this.form.tranDate = null
        }
        // this.companyLayout.lockAccountingPeriodTo
        // this.form.tranDate = null
      }
    },
    async useBalance() {
      if (!this.listCDForUseBalance.length) await this.getListCRForUseBalance()
      this.$refs.CDUseBalance.open()
    },
    async createCashDisbursementUseBalance(cashDisbursementHeader) {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.post(`/api/v1/cashDisbursementOverPayment/create?companyId=${this.$route.query.companyId}`, {
          cashDisbursementHeaderIdIn: cashDisbursementHeader.id,
          cashDisbursementPaymentsList: this.listCDForUseBalance
        })
      } catch (error) {
        console.log(error)
      } finally {
        loader.hide()
      }
    },
    initAppliedUnderOverPMTBal(value) {
      this.form.appliedUnderOverPMTBal = value
      this.calculateResults()
    },
    async getListCRForUseBalance() {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.get(`/api/v1/cashDisbursement/byVendorOverPayment?vendorId=${this.form.vendorId}&startDate=null&endDate=null`)
        this.listCDForUseBalance = data.result.table.map(({ date, cdid, owing, overpmtcr, amtApplied = 0,  id:cashDisbursementHeaderIdOut }) => ({ date, cdid, owing, overpmtcr, amtApplied,  cashDisbursementHeaderIdOut }))
      } catch (error) {
        console.log(error)
      } finally {
        loader.hide()
      }
    },
    async init() {
      let loader = this.$loading.show();
      try {
        await this.directories()
        const response = await axios.get(`/api/v1/items/active-list?companyId=${this.$route.query.companyId}`)
        this.accountsRevenueSales = response.data.list.filter(val => val.purchase)
        await this.getAccountOnlyTax()
        await this.checkTaxes()
        if (this.$route.params.id) {
          this.disabledForm = true
          const item = await this.item(this.$route.params.id)
          if (item.isBuyingItems) {
            await this.changeTypeOfExpenditure('isBuyingItems')
          }
          await this.itemImg(this.$route.params.id)
        }
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    async getWarehouses() {
      try {
        const { data } = await axios.post(`/api/v1/inventories/list?companyId=${this.$route.query.companyId}`)
        return data.inventoryList
      } catch (err) {
        console.log(err)
      }
    },
    async item(id) {
      try {
        const whList = await this.getWarehouses()
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.get(`/api/v1/cashDisbursement/item?id=${id}`)
        this.isBlock = data.item.isBlock
        this.status = data.item.status
        this.form.vendorId = data.item.vendorId
        await this.setVendor(data.item.vendorId)
        await this.getVendorUnderOverPayment(data.item.vendorId)
        // TODO getClientUnderOverPayment
        this.form.appliedUnderOverPMTBal = data.item.appliedUnderOverPMTBal
        this.form.vendorTin = data.item.vendorTin

        this.form.isWHTaxSwitch = data.item.isWHTaxToggle
        this.form.isVatWHTaxSwitch = data.item.isVatWHTaxToggle
        this.form.isUseBalance = data.item.isUseBalanceToggle

        this.form.typeOfBusiness = data.item.typeOfBusiness
        this.form.paymentTerms = data.item.paymentTerms
        this.form.serviceVATCode = data.item.serviceVATCode
        this.form.productVATCode = data.item.productVATCode

        this.listCDForUseBalance = data.item.cashDisbursementOverPayments.map(({ date, cdid, owing, overpmtcr, amtApplied,  cashDisbursementHeaderIdOut }) => ({ date, cdid, owing, overpmtcr, amtApplied,  cashDisbursementHeaderIdOut }))

        this.form.paymentCurrency = data.item.paymentCurrency
        this.form.exchangeRate = data.item.fxRate
        this.form.transactionId = data.item.tranId
        this.form.paymentFor = data.item.paymentFor
        this.transaction = data.item.transaction ? data.item.transaction : {}
        this.isSendToAcc = data.item.transaction ? data.item.transaction.isSendToAcc : false
        this.form.createByFullName = data.item.createByFullName
        this.transactionNo = data.item.transaction.transactionNo
        this.form.tranDate = moment(data.item.cdDate).format("MM-DD-YYYY")
        if (data.item.isCostService) {
          this.form.typeOfExpenditure = 'changeDirectToCost'
          this.form.typeOfSale = 'isCostService'
        } else if (data.item.isExpense) {
          this.form.typeOfExpenditure = 'changeDirectToCost'
          this.form.typeOfSale = 'isExpense'
        } else if (data.item.isChangeDirectToCostBoth) {
          this.form.typeOfExpenditure = 'changeDirectToCost'
          this.form.typeOfSale = 'isBoth'
        } else if (data.item.isBuyingItems) {
          this.form.typeOfExpenditure = 'isBuyingItems'
          // this.form.typeOfSale = 'isBuyingItems'
        } else if (data.item.isBoth) {
          this.form.typeOfExpenditure = 'isBoth'
          // this.form.typeOfSale = 'isBoth'
          this.form.salesServiceItems = data.item.cashDisbursementDetails.filter(val => val.typeTable === 'salesServiceItems').map(val => ({
            ...val,
            discountAccountId: val.discountAccountId,
            no: val.accountNumber,
            revenueAccount: val.accountId,
            description: val.details,
            price: val.unitPrice,
            unit: val.unitId,
            qty: val.qty,
            totalAmount: val.totalAmount,
            isVendorWHTax: Boolean(val.isVendorWHTax),
            taxCode: val.taxCodeId,
            taxRate: val.taxRate,
            entityTypeId: val.allocatedTo,
            parentId: val.whsengproId,
            userId: val.euId,
            buList: val.bu ? [val.bu] : [],
            parentList: val.entity ? [val.entity] : [],
            taskList: val.task ? [val.task] : [],
            userList: val.user ? [{ userId: val.user.id, userFullName: val.user.name }] : [],
            whList: whList,
            entityTypeList: [
              { id: 2, name: 'Business Unit' },
              { id: 4, name: 'Warehouse' },
              { id: 3, name: 'Engagement' },
              { id: 1, name: 'Project' },
            ],
          }))
        }
        this.form.purchasingNotes = data.item.purchasingNotes
        this.form.amountsAre = data.item.amountsAre
        if (data.item.cashDisbursementDetails.filter(val => !val.isOtherRevenue && val.typeTable === 'serviceRevenue').length) {
          this.form.serviceRevenue = data.item.cashDisbursementDetails.filter(val => !val.isOtherRevenue && val.typeTable === 'serviceRevenue').map(val => ({
            ...val,
            discountAccountId: val.discountAccountId,
            no: val.accountNumber,
            revenueAccount: val.accountId,
            description: val.details,
            price: val.unitPrice,
            unit: val.unitId,
            qty: val.qty,
            totalAmount: val.totalAmount,
            isVendorWHTax: Boolean(val.isVendorWHTax),
            taxCode: val.taxCodeId,
            taxRate: val.taxRate,
            entityTypeId: val.allocatedTo,
            parentId: val.whsengproId,
            userId: val.euId,
            buList: val.bu ? [val.bu] : [],
            parentList: val.entity ? [val.entity] : [],
            taskList: val.task ? [val.task] : [],
            userList: val.user ? [{ userId: val.user.id, userFullName: val.user.name }] : [],
            whList: whList,
            entityTypeList: [
              { id: 2, name: 'Business Unit' },
              { id: 4, name: 'Warehouse' },
              { id: 3, name: 'Engagement' },
              { id: 1, name: 'Project' },
            ],
          }))
        }

        if (data.item.cashDisbursementDetails.filter(val => val.isOtherRevenue).length) {
          this.form.serviceRevenue2 = data.item.cashDisbursementDetails.filter(val => val.isOtherRevenue).map(val => ({
            ...val,
            discountAccountId: val.discountAccountId,
            no: val.accountNumber,
            revenueAccount: val.accountId,
            description: val.details,
            price: val.unitPrice,
            unit: val.unitId,
            qty: val.qty,
            totalAmount: val.totalAmount,
            isVendorWHTax: Boolean(val.isVendorWHTax),
            taxCode: val.taxCodeId,
            taxRate: val.taxRate,
            entityTypeId: val.allocatedTo,
            parentId: val.whsengproId,
            userId: val.euId,
            buList: val.bu ? [val.bu] : [],
            parentList: val.entity ? [val.entity] : [],
            taskList: val.task ? [val.task] : [],
            userList: val.user ? [{ userId: val.user.id, userFullName: val.user.name }] : [],
            whList: whList,
            entityTypeList: [
              { id: 2, name: 'Business Unit' },
              { id: 4, name: 'Warehouse' },
              { id: 3, name: 'Engagement' },
              { id: 1, name: 'Project' },
            ],
          }))
        }

        if (data.item.cashDisbursementDetails.filter(val => val.isNonCost).length) {
          this.form.nonCost = data.item.cashDisbursementDetails.filter(val => val.isNonCost).map(val => ({
            ...val,
            discountAccountId: val.discountAccountId,
            no: val.accountNumber,
            revenueAccount: val.accountId,
            description: val.details,
            price: val.unitPrice,
            unit: val.unitId,
            qty: val.qty,
            totalAmount: val.totalAmount,
            isVendorWHTax: Boolean(val.isVendorWHTax),
            taxCode: val.taxCodeId,
            taxRate: val.taxRate,
            entityTypeId: val.allocatedTo,
            parentId: val.whsengproId,
            userId: val.euId,
            buList: val.bu ? [val.bu] : [],
            parentList: val.entity ? [val.entity] : [],
            taskList: val.task ? [val.task] : [],
            userList: val.user ? [{ userId: val.user.id, userFullName: val.user.name }] : [],
            whList: whList,
            entityTypeList: [
              { id: 2, name: 'Business Unit' },
              { id: 4, name: 'Warehouse' },
              { id: 3, name: 'Engagement' },
              { id: 1, name: 'Project' },
            ],
          }))
        }

        this.form.generalSwitch = !!data.item.cashDisbursementDetails.filter(val => !val.isOtherRevenue && val.typeTable === 'serviceRevenue').length
        this.form.salesDirectToMiscellaneous = !!data.item.cashDisbursementDetails.filter(val => val.isOtherRevenue).length
        this.form.chargeDirectToNonCostAccount = !!data.item.cashDisbursementDetails.filter(val => val.isNonCost).length
        if (data.item.isSinglePayment) {
          this.form.modeOfPayment = 1
        } else if (data.item.isSplitPayment) {
          this.form.modeOfPayment = 2
        } else if (data.item.isClearingAccount) {
          this.form.modeOfPayment = 3
        } else if (data.item.isPDC) {
          this.form.modeOfPayment = 4
        }
        if (this.form.modeOfPayment === 1) {
          // this.$refs.singlePM.form.paidDate = moment(data.item.cashDisbursementPayments[0].paidDate).format("MM-DD-YYYY")
          this.form.paidDate = moment(data.item.cashDisbursementPayments[0].paidDate).format("MM-DD-YYYY")
          this.$refs.singlePM.form.paymentMethodId = data.item.cashDisbursementPayments[0].paymentMethodId
          // await this.$nextTick()
          this.$refs.singlePM.changePaymentMethod()
          this.$refs.singlePM.form.depositAccountId = data.item.cashDisbursementPayments[0].depositAccountId
          this.$refs.singlePM.form.chequeRefNo = data.item.cashDisbursementPayments[0].chequeRefNo
          this.$refs.singlePM.form.amountPaid = data.item.cashDisbursementPayments[0].amountPaid
        }
        if (this.form.modeOfPayment === 2) {
          const items = data.item.cashDisbursementPayments.map(val => {
            const pm = this.paymentMethodList.find(item => item.id === val.paymentMethodId)
            return {
              paidDate: moment(val.paidDate).format("MM-DD-YYYY"),
              paymentMethodId: val.paymentMethodId,
              depositAccountId: val.depositAccountId,
              chequeRefNo: val.chequeRefNo,
              amountPaid: val.amountPaid,
              depositAccountList: pm ? pm.accounts : [],
              balanceToPay: val.balanceToPay,
            }
          })
          await this.$nextTick()
          this.$refs.splitPM.form.items = items
          // await this.calculatebalanceToPay()
        }
        this.form.paidBy = data.item.paidBy
        this.form.forUser = data.item.forUser
        return data.item
      } catch (err) {
        console.log(err)
      }
    },
    async itemImg(id) {
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.get(`/api/v1/entityFiles/list?entityId=${id}&entityTypeId=81`)
        if (data.list.length) {
          this.imgPreviewSrc = data.list[0].url
        }
      } catch (err) {
        console.log(err)
      }
    },
    async changeVendor(val) {
      this.getVendorUnderOverPayment(val)
      const vendor = this.vendorList.find(vendor => vendor.id === val)
      if (vendor.currency === this.companyLayout.currency.code) {
        this.form.paymentCurrency = this.companyLayout.currency.code
      }
      // this.form.vendorContactId = null
      await this.getVendorRate(vendor)
      this.form.vendorEmail = vendor.email
      this.form.currency = vendor.currency
      this.form.vendorTin = vendor.tin

      this.form.typeOfBusiness = vendor.typeOfBusiness
      this.form.paymentTerms = vendor.paymentTerms

      if (vendor.typeOfBusiness === 'Service') {
        this.form.serviceVATCode = vendor.saleTax ? vendor.saleTax.code : null
        this.form.productVATCode = null
      } else if (vendor.typeOfBusiness === 'Products') {
        this.form.serviceVATCode = null
        this.form.productVATCode = vendor.saleTax ? vendor.saleTax.code : null
      } else {
        this.form.serviceVATCode = vendor.saleTax ? vendor.saleTax.code : null
        this.form.productVATCode = vendor.saleTax ? vendor.saleTax.code : null
      }

      this.form.isVatWHTaxExapnded = vendor.applyExplandedVatWHTax
      this.form.isVatWHTaxSwitch = false
      this.form.isWHTaxExpanded = vendor.applyWHTaxExplanded
      this.form.isWHTaxSwitch = false
      this.form.saleTaxId = vendor.saleTaxId
      this.form.applyVatWHTaxObj = vendor.applyExplandedVatWHTaxObj
      this.form.applyWHTaxObj = vendor.applyWHTaxExplandedObj
      this.form.whtaxExpandedRate = this.form.applyWHTaxObj ? +this.form.applyWHTaxObj.rate : 0
      this.form.vatWhtaxExpandedRate = this.form.applyVatWHTaxObj ? +this.form.applyVatWHTaxObj.rate : 0

      // clear Apply Over Payments
      this.listCDForUseBalance = []

      // clear
      this.form.isUseBalance = false
      this.form.appliedUnderOverPMTBal = 0
      this.setTaxCodeToTable()
      // this.$refs.cashDisbursementstModal.openModal()
    },
    getVendorUnderOverPayment(id) {
      return new Promise(resolve => {
        const loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/cashDisbursement/vendorUnderOverPayment?vendorId=${id}`).then(response => {
          const { data } = response
          this.form.veResult = data.result.veResult
          this.form.veResultAfterRate = data.result.veResultAfterRate
          loader.hide()
          resolve()
        }).catch(err => {
          console.log(err)
          loader.hide()
        })
      })
    },
    async setVendor(val) {
      const vendor = this.vendorList.find(vendor => vendor.id === val)
      this.form.vendorEmail = vendor.email
      this.form.currency = vendor.currency
      this.form.isVatWHTaxExapnded = vendor.applyExplandedVatWHTax
      this.form.isWHTaxExpanded = vendor.applyWHTaxExplanded
      this.form.saleTaxId = vendor.saleTaxId
      this.form.applyVatWHTaxObj = vendor.applyExplandedVatWHTaxObj
      this.form.applyWHTaxObj = vendor.applyWHTaxExplandedObj
      this.form.whtaxExpandedRate = this.form.applyWHTaxObj ? +this.form.applyWHTaxObj.rate : 0
      this.form.vatWhtaxExpandedRate = this.form.applyVatWHTaxObj ? +this.form.applyVatWHTaxObj.rate : 0
      // this.setTaxCodeToTable()
    },
    async getVendorRate(vendor) {
      let loader = this.$loading.show();
      try {
        console.log(`[FastForex FetchOne Request] URL: https://api.fastforex.io/fetch-one?from=${vendor.currency}&to=${this.companyLayout.currency.code}&api_key=${FASTFOREX_API_KEY}`);
        const { data } = await new Promise((resolve) => {
          resolve({
            data: {
              result: {
                [this.companyLayout.currency.code]: 1
              }
            }
          })
        })
        this.form.exchangeRate = data.result[this.companyLayout.currency.code]
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    setTaxCodeToTable() {
      return new Promise((resolve) => {
        switch(this.form.amountsAre) {
          case 1:
            this.form.serviceRevenue = this.form.serviceRevenue.map((item) => ({...item, taxCode: this.salesTaxListNoTaxSP ? this.salesTaxListNoTaxSP.id : null }))
            this.form.serviceRevenue2 = this.form.serviceRevenue2.map((item) => ({...item, taxCode: this.salesTaxListNoTaxSP ? this.salesTaxListNoTaxSP.id : null }))
            this.form.salesServiceItems = this.form.salesServiceItems.map((item) => ({...item, taxCode: this.salesTaxListNoTaxSP ? this.salesTaxListNoTaxSP.id : null }))
            this.form.nonCost = this.form.nonCost.map((item) => ({...item, taxCode: this.salesTaxListNoTaxSP ? this.salesTaxListNoTaxSP.id : null }))
            break
            case 2:
            case 3:
              this.form.serviceRevenue = this.form.serviceRevenue.map((item) => ({...item, taxCode: this.form.saleTaxId }))
              this.form.serviceRevenue2 = this.form.serviceRevenue2.map((item) => ({...item, taxCode: this.form.saleTaxId }))
              this.form.salesServiceItems = this.form.salesServiceItems.map((item) => ({...item, taxCode: this.form.saleTaxId }))
              this.form.nonCost = this.form.nonCost.map((item) => ({...item, taxCode: this.form.saleTaxId }))
              break
          case 4:
            this.form.serviceRevenue = this.form.serviceRevenue.map((item) => ({...item, taxCode: this.salesTaxListExemptTax ? this.salesTaxListExemptTax.id : null }))
            this.form.serviceRevenue2 = this.form.serviceRevenue2.map((item) => ({...item, taxCode: this.salesTaxListExemptTax ? this.salesTaxListExemptTax.id : null }))
            this.form.salesServiceItems = this.form.salesServiceItems.map((item) => ({...item, taxCode: this.salesTaxListExemptTax ? this.salesTaxListExemptTax.id : null }))
            this.form.nonCost = this.form.nonCost.map((item) => ({...item, taxCode: this.salesTaxListExemptTax ? this.salesTaxListExemptTax.id : null }))
            break
          default:
            this.form.serviceRevenue = this.form.serviceRevenue.map((item) => ({...item, taxCode: null }))
            this.form.serviceRevenue2 = this.form.serviceRevenue2.map((item) => ({...item, taxCode: null }))
            this.form.salesServiceItems = this.form.salesServiceItems.map((item) => ({...item, taxCode: null }))
            this.form.nonCost = this.form.nonCost.map((item) => ({...item, taxCode: null }))
        }
        resolve('ok')
      })
    },
    directories() {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('getCompanyLayout').then(() => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.get(`/api/v1/cashDisbursement/directories?companyId=${this.$route.query.companyId}&countryId=${this.companyLayout.countryId}`)
              .then(response => {
                this.vendorList = response.data.directories.vendor
                this.forUserList = response.data.directories.forUser
                this.accountsCostOFService = response.data.directories.accountsCostOFService
                this.accountsExpenses = response.data.directories.accountsExpenses
                this.accountsRevenue = response.data.directories.accountsRevenue
                this.accountsAll = response.data.directories.accountsAll
                this.accountsMiscellaneousIncome = response.data.directories.accountsMiscellaneousIncome
                this.accountsOtherExpenditures = response.data.directories.accountsOtherExpenditures
                this.units = response.data.directories.unit
                this.paymentMethodList = response.data.directories.paymentMethodList
                resolve('ok')
              })
              .catch(error => {
                console.log(error)
                reject('error')
              });
        })
      })
    },
    getAccountOnlyTax() {
      return new Promise((resolve, reject) => {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.get(`/api/v1/account/accountOnlyTax?companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log('response', response)
              this.salesTaxList = response.data.list ? response.data.list.input : []
              resolve('ok')
            })
            .catch(error => {
              reject('error')
            })
      })
    },
    calculateBalanceToPay() {
      const ifClientCurrency = this.form.paymentCurrency === this.form.currency

      this.$refs.splitPM.form.items.forEach((val, index) => {
        if (index === 0) {
          val.balanceToPay = (ifClientCurrency ? this.results.amountOwing : this.results.amountOwingVendorCurrency) - val.amountPaid
        } else {
          val.balanceToPay = this.$refs.splitPM.form.items[index-1].balanceToPay - val.amountPaid
        }
      })
    },
    checkTaxes() {
      if (!this.salesTaxListExemptTax || !this.salesTaxListNoTaxSP || !this.salesTaxListWithZeroRate) {
        this.$alert(`For our system to function correctly, it is necessary to establish the appropriate taxes. Please ensure that the Tax Libraries are configured with No tax, Zero rated, and Tax Exempt options.`, 'Warning', {
          confirmButtonText: 'OK',
          type: 'info',
          callback: action => {
            this.$router.push(`/settings-tax-libraries?companyId=${this.$route.query.companyId}`)
          }
        });
      }
    },
    addNewItem(index, row) {
      const itm = {
        no: null,
        revenueAccount: null,
        description: null,
        price: 0,
        unit: null,
        qty: 1,
        scpwdDiscountRate: null,
        discountAmount: null,
        totalAmount: 0,
        taxCode: this.form.saleTaxId,
        taxRate: 0,
        isVendorWHTax: false,
        isScPwd: false,
        entityTypeId: null,
        warehouseId: null,
        buId: null,
        parentId: null,
        taskId: null,
        userId: null,
        // lists
        whList: [],
        buList: [],
        parentList: [],
        taskList: [],
        userList: [],
        itemId: null,
        entityTypeList: [
          { id: 2, name: 'Business Unit' },
          { id: 4, name: 'Warehouse' },
          { id: 3, name: 'Engagement' },
          { id: 1, name: 'Project' },
        ],
        typeTable: 'serviceRevenue',
        discountAccountId: null,
      };

      this.form.serviceRevenue.push(itm)
      return row
    },
    addNewItem2(index, row) {
      const itm = {
        no: null,
        revenueAccount: null,
        description: null,
        price: 0,
        unit: null,
        qty: 1,
        scpwdDiscountRate: null,
        discountAmount: null,
        totalAmount: 0,
        taxCode: this.form.saleTaxId,
        taxRate: 0,
        isVendorWHTax: false,
        isScPwd: false,
        entityTypeId: null,
        warehouseId: null,
        buId: null,
        parentId: null,
        taskId: null,
        userId: null,
        // lists
        whList: [],
        buList: [],
        parentList: [],
        taskList: [],
        userList: [],
        itemId: null,
        entityTypeList: [
          { id: 2, name: 'Business Unit' },
          { id: 4, name: 'Warehouse' },
          { id: 3, name: 'Engagement' },
          { id: 1, name: 'Project' },
        ],
        typeTable: 'serviceRevenue2',
        discountAccountId: null,
      };

      this.form.serviceRevenue2.push(itm)
      return row
    },
    addNewItem3(index, row) {
      const itm = {
        no: null,
        revenueAccount: null,
        description: null,
        price: 0,
        unit: null,
        qty: 1,
        scpwdDiscountRate: null,
        discountAmount: null,
        totalAmount: 0,
        taxCode: this.form.saleTaxId,
        taxRate: 0,
        isVendorWHTax: false,
        isScPwd: false,
        entityTypeId: null,
        warehouseId: null,
        buId: null,
        parentId: null,
        taskId: null,
        userId: null,
        // lists
        whList: [],
        buList: [],
        parentList: [],
        taskList: [],
        userList: [],
        itemId: null,
        entityTypeList: [
          { id: 2, name: 'Business Unit' },
          { id: 4, name: 'Warehouse' },
          { id: 3, name: 'Engagement' },
          { id: 1, name: 'Project' },
        ],
        typeTable: 'nonCost',
        discountAccountId: null,
      };

      this.form.nonCost.push(itm)
      return row
    },
    addNewItem4(index, row) {
      const itm = {
        no: null,
        revenueAccount: null,
        description: null,
        price: 0,
        unit: null,
        qty: 1,
        scpwdDiscountRate: null,
        discountAmount: null,
        totalAmount: 0,
        taxCode: this.form.saleTaxId,
        taxRate: 0,
        isVendorWHTax: false,
        isScPwd: false,
        entityTypeId: null,
        warehouseId: null,
        buId: null,
        parentId: null,
        taskId: null,
        userId: null,
        // lists
        whList: [],
        buList: [],
        parentList: [],
        taskList: [],
        userList: [],
        itemId: null,
        entityTypeList: [
          { id: 2, name: 'Business Unit' },
          { id: 4, name: 'Warehouse' },
          { id: 3, name: 'Engagement' },
          { id: 1, name: 'Project' },
        ],
        typeTable: 'salesServiceItems',
        discountAccountId: null,
      };

      this.form.salesServiceItems.push(itm)
      return row
    },
    removeItem(index){
      this.form.serviceRevenue = this.form.serviceRevenue.filter((val, i) => i !== index)
    },
    removeItem2(index) {
      this.form.serviceRevenue2 = this.form.serviceRevenue2.filter((val, i) => i !== index)
    },
    removeItem3(index) {
      this.form.nonCost = this.form.nonCost.filter((val, i) => i !== index)
    },
    removeItem4(index) {
      this.form.salesServiceItems = this.form.salesServiceItems.filter((val, i) => i !== index)
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    async add(id) {
      if (this.form.typeOfExpenditure !== 'isBoth') {
        if (!this.form.generalSwitch && !this.form.salesDirectToMiscellaneous && !this.form.chargeDirectToNonCostAccount) {
          this.$message({
            message: 'Fill in at least one table',
            type: 'warning'
          });
          return
        }
      }

      let modePmValid = false
      let table1Valid = true
      let table2Valid = true
      let table3Valid = true
      let table4Valid = true
      switch (this.form.modeOfPayment) {
        case 1:
          modePmValid = await this.$refs.singlePM.validate()
          break
        case 2:
          modePmValid = await this.$refs.splitPM.validate()
          break
        case 3:
          break
        case 4:
          break
      }

      // validate 1 table
      if (this.form.generalSwitch && this.$refs['crServiceRevenue']) {
        const table1 = this.$refs['crServiceRevenue'].$refs.form
        table1.validate(async (valid) => {
          table1Valid = valid
        })
      }

      // validate 2 table
      if (this.form.salesDirectToMiscellaneous && this.$refs['crServiceRevenue2']) {
        const table2 = this.$refs['crServiceRevenue2'].$refs.form
        table2.validate(async (valid) => {
          table2Valid = valid
        })
      }

      // validate 3 table
      if (this.form.chargeDirectToNonCostAccount && this.$refs['cdNonCost']) {
        const table2 = this.$refs['cdNonCost'].$refs.form
        table2.validate(async (valid) => {
          table3Valid = valid
        })
      }

      // validate 4 table
      if (this.form.typeOfExpenditure === 'isBoth' && this.$refs['cdSalesServiceItems']) {
        const table4 = this.$refs['cdSalesServiceItems'].$refs.form
        table4.validate(async (valid) => {
          table4Valid = valid
        })
      }

      console.log('===', modePmValid, table1Valid, table2Valid, table3Valid, table4Valid)

      this.$refs['form'].validate(async (valid) => {
        try {
          if (valid && modePmValid && table1Valid && table2Valid && table3Valid && table4Valid) {
            let loader = this.$loading.show()
            const header = await this.headerRequest(id)
            this.disabledForm = true
            this.updatedState = false
            await this.createCashDisbursement(header)
            await this.createCashDisbursementDetail(header)
            await this.createCashDisbursementUseBalance(header)
            await this.createCashDisbursementTransaction(header)
            if (this.imgPreview) {
              await this.createFile(header, this.imgPreview)
            }
            loader.hide()
            console.log('===', id, header)
            if (!id && header) {
              this.$router.push(`/cash-disbursements/${header.id}?companyId=${this.$route.query.companyId}`)
            }
          }
        } catch (err) {
          console.log(err)
        }
      })
    },
    async addAndNew(id) {
      if (this.form.typeOfExpenditure !== 'isBoth') {
        if (!this.form.generalSwitch && !this.form.salesDirectToMiscellaneous && !this.form.chargeDirectToNonCostAccount) {
          this.$message({
            message: 'Fill in at least one table',
            type: 'warning'
          });
          return
        }
      }

      let modePmValid = false
      let table1Valid = true
      let table2Valid = true
      let table3Valid = true
      let table4Valid = true
      switch (this.form.modeOfPayment) {
        case 1:
          modePmValid = await this.$refs.singlePM.validate()
          break
        case 2:
          modePmValid = await this.$refs.splitPM.validate()
          break
        case 3:
          break
        case 4:
          break
      }

      // validate 1 table
      if (this.form.generalSwitch && this.$refs['crServiceRevenue']) {
        const table1 = this.$refs['crServiceRevenue'].$refs.form
        table1.validate(async (valid) => {
          table1Valid = valid
        })
      }

      // validate 2 table
      if (this.form.salesDirectToMiscellaneous && this.$refs['crServiceRevenue2']) {
        const table2 = this.$refs['crServiceRevenue2'].$refs.form
        table2.validate(async (valid) => {
          table2Valid = valid
        })
      }

      // validate 3 table
      if (this.form.chargeDirectToNonCostAccount && this.$refs['cdNonCost']) {
        const table2 = this.$refs['cdNonCost'].$refs.form
        table2.validate(async (valid) => {
          table3Valid = valid
        })
      }

      // validate 4 table
      if (this.form.typeOfExpenditure === 'isBoth' && this.$refs['cdSalesServiceItems']) {
        const table4 = this.$refs['cdSalesServiceItems'].$refs.form
        table4.validate(async (valid) => {
          table4Valid = valid
        })
      }

      console.log('===', modePmValid, table1Valid, table2Valid, table3Valid, table4Valid)

      this.$refs['form'].validate(async (valid) => {
        try {
          if (valid && modePmValid && table1Valid && table2Valid && table3Valid && table4Valid) {
            let loader = this.$loading.show()
            const header = await this.headerRequest(id)
            this.disabledForm = true
            this.updatedState = false
            await this.createCashDisbursement(header)
            await this.createCashDisbursementDetail(header)
            await this.createCashDisbursementUseBalance(header)
            await this.createCashDisbursementTransaction(header)

            // this.$refs['crServiceRevenue'].$refs['form'].resetFields()
            if (this.form.generalSwitch) this.$refs['crServiceRevenue'].$refs['form'].resetFields()
            if (this.form.salesDirectToMiscellaneous) this.$refs['crServiceRevenue2'].$refs['form'].resetFields()
            if (this.form.salesDirectToNonRevenueAccount) this.$refs['cdNonCost'].$refs['form'].resetFields()
            if (this.form.typeOfSale === 'isBoth') this.$refs['cdSalesServiceItems'].$refs['form'].resetFields()
            if (this.form.modeOfPayment === 1) this.$refs['singlePM'].$refs['form'].resetFields()
            if (this.form.modeOfPayment === 2) this.$refs['splitPM'].$refs['form'].resetFields()
            this.$refs['form'].resetFields()
            loader.hide()
            this.disabledForm = false
            this.updatedState = true
            this.isBlock = false
          }
        } catch (err) {
          console.log(err)
        }
      })
    },
    async checked(id) {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.get(`/api/v1/cashDisbursement/check?transactionId=${this.form.transactionId}&cashDisbursementHeaderId=${this.$route.params.id}&companyId=${this.$route.query.companyId}&transactionNo=${this.transactionNo}`)
        this.notification("Success", "Cash Disbursement Checked", "success");
        loader.hide()
        await this.init()
      } catch (err) {
        loader.hide()
      }
    },
    async sendToAccountant(id) {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.post(`/api/v1/cashDisbursement/send-to-accountant?transactionId=${this.form.transactionId}&companyId=${this.$route.query.companyId}&tab=cashDisbursements&transactionNo=${this.transactionNo}&cashDisbursementHeaderId=${this.$route.params.id}`)
        this.notification("Success", "", "success");
        loader.hide()
        await this.init()
      } catch (err) {
        loader.hide()
      }
    },
    voidCashDisbursement(id) {
      this.$confirm('Do you want to Void current Cash Disbursement?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'info'
      }).then(async () => {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          await axios.get(`/api/v1/cashDisbursement/void?cashDisbursementHeaderId=${id}&companyId=${this.$route.query.companyId}&transactionNo=${this.transactionNo}&transactionId=${this.form.transactionId}`)
          this.notification("Success", "Void", "success");
          loader.hide()
          await this.init()
        } catch (err) {
          loader.hide()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Void canceled'
        });
      });
    },
    async deleteCashDisbursement(id) {
      this.$confirm('Do you want to Delete current Cash Disbursement?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'info'
      }).then(async () => {
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          await axios.get(`/api/v1/cashDisbursement/delete?cashDisbursementHeaderId=${id}&companyId=${this.$route.query.companyId}&transactionNo=${this.transactionNo}&transactionId=${this.form.transactionId}`)
          this.notification("Success", "Cash Disbursement deleted", "success");
          loader.hide()
          this.$router.push(`/journal-and-gl?companyId=${this.$route.query.companyId}&tab=cashDisbursements`)
        } catch (err) {
          loader.hide()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    async record(id) {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.get(`/api/v1/cashDisbursement/post?cashDisbursementHeaderId=${id}&companyId=${this.$route.query.companyId}&transactionNo=${this.transactionNo}&transactionId=${this.form.transactionId}`)
        this.notification("Success", "Cash Disbursement recorded", "success");
        loader.hide()
        await this.init()
      } catch (err) {
        loader.hide()
      }
    },
    async headerRequest(id) {
      try {
        const payload = {
          cdDate: this.form.tranDate,
          vendorId: this.form.vendorId,
          vendorTin: this.form.vendorTin,
          typeOfBusiness: this.form.typeOfBusiness,
          paymentTerms: this.form.paymentTerms,
          serviceVATCode: this.form.serviceVATCode,
          productVATCode: this.form.productVATCode,
          vendorCurrency: this.form.currency,
          paymentCurrency: this.form.paymentCurrency,
          fxRate: this.form.exchangeRate,
          whtaxExpandedRate: this.form.whtaxExpandedRate,
          vatWhtaxExpandedRate: this.form.vatWhtaxExpandedRate,
          isWHTaxExpanded: Boolean(this.form.isWHTaxExpanded),
          isWHTaxToggle: Boolean(this.form.isWHTaxSwitch),
          isVatWHTaxToggle: Boolean(this.form.isVatWHTaxSwitch),
          isUseBalanceToggle: Boolean(this.form.isUseBalance),
          isVatWHTaxExapnded: Boolean(this.form.isVatWHTaxExapnded),
          isSinglePayment: this.form.modeOfPayment === 1,
          isSplitPayment: this.form.modeOfPayment === 2,
          isClearingAccount: this.form.modeOfPayment === 3,
          isPDC: this.form.modeOfPayment === 4,
          paidBy: this.form.paidBy,
          forUser: this.form.forUser,
          isCostService: this.form.typeOfExpenditure === 'changeDirectToCost' && this.form.typeOfSale === 'isCostService',
          isExpense: this.form.typeOfExpenditure === 'changeDirectToCost' && this.form.typeOfSale === 'isExpense',
          isChangeDirectToCostBoth: this.form.typeOfExpenditure === 'changeDirectToCost' && this.form.typeOfSale === 'isBoth',
          isBuyingItems: this.form.typeOfExpenditure === 'isBuyingItems',
          isBoth: this.form.typeOfExpenditure === 'isBoth',
          amountsAre: this.form.amountsAre,
          purchasingNotes: this.form.purchasingNotes,
          paymentFor: this.form.paymentFor,
          otherExpendituresCharges: this.results.otherExpendituresCharges,
          nonCostCharges: this.results.nonCostCharges,
          vatableAmount: this.results.vatableAmount,
          vatExAmount: this.results.vatExAmount,
          zeroRatedAmount: this.results.zeroRatedAmount,
          addVat: this.results.vatAmount,
          totalAmount: this.results.totalAmountVatInclusinve,
          amountVatExclusive: this.results.amountVatExcluded,
          addVatAmount: this.results.addVatAmount,
          totalAmountVatInclusive: this.results.totalAmountNoTax,
          lessVatWHTaxExpanded: this.results.lessCreditableWithholdingVat,
          lessWHTaxExpanded: this.results.lessCreditableWithholdingTax,
          amountOwing: this.results.amountOwing,
          amountPaid: this.results.receivedAmount,
          balanceOwing: this.results.balanceOwing,
          amountOwingVendorCurrency: this.results.amountOwingVendorCurrency,
          balanceOwingVendorCurrency: this.results.balanceOwingVendorCurrency,
          templateName: null, //TODO ???
          cvNumber: null, //TODO ???,
          issueDate: null, //TODO ???,
          isECV: false, //TODO ???
          isEN: false, //TODO ???
          isEL: false, //TODO ???
          vendorContact: null, //TODO ???
          vendorEmail: this.form.vendorEmail,
          // TODO
          discount: this.results.discount,
          isCostExpenses: true,
          isPurchaseAsset: false,
          isPrepaymentsDeposits: false,
          isOthers: false,
          appliedUnderOverPMTBal: this.form.appliedUnderOverPMTBal,
        }
        console.log('payload', payload)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const { data } = await axios.post(id ? `/api/v1/cashDisbursementHeader/update?cashDisbursementHeaderId=${id}&companyId=${this.$route.query.companyId}&transactionNo=${this.transactionNo}&transactionId=${this.form.transactionId}` : `/api/v1/cashDisbursementHeader/create?companyId=${this.$route.query.companyId}`, payload)
        // const response = await axios.get(`/api/v1/cashDisbursement/item?id=${data.id}`)
        // this.transactionNo = response.data.item.transaction.transactionNo
        this.notification("Success", id ? "Cash Disbursement updated" : "Cash Disbursement added", "success");

        return data
      } catch (err){
        console.log(err)
      }
    },
    async createCashDisbursement(cashDisbursementHeader) {
      try {
        const payload = {
          cashDisbursementPaymentsList: []
        }

        let data = []
        switch (this.form.modeOfPayment) {
          case 1:
            data.push(this.$refs.singlePM.form)
            break
          case 2:
            data = this.$refs.splitPM.form.items.filter(val => Boolean(val.paymentMethodId))
            break
          case 3:

            break
          case 4:

            break
        }

        data.map(row => {
          const item = {
            cashDisbursementHeaderId: cashDisbursementHeader.id,
            paidDate: this.form.paidDate,
            paymentMethodId: row.paymentMethodId,
            depositAccountId: row.depositAccountId,
            chequeRefNo: row.chequeRefNo,
            dateOfCheque: null,
            chequeIssueDate: null,
            chequeIssuedBy: null,
            amountPaid: row.amountPaid,
            balanceToPay: this.form.modeOfPayment === 2 ? row.balanceToPay : null, //TODO ???
            paymentStatus: null,
            // TODO
            foreignAmountPaid: 0.00,
            paymentCurrency: null
          }
          payload.cashDisbursementPaymentsList.push(item)
        })

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.post(`/api/v1/cashDisbursementPayment/create?companyId=${this.$route.query.companyId}`, payload)
      } catch (err) {
        console.log(err)
      }
    },
    async createCashDisbursementDetail(cashDisbursementHeader) {
      try {
        const payload = {
          cashDisbursementDetailsList: []
        }

        let table = []

        if (this.form.generalSwitch) {
          table = [...this.form.serviceRevenue]
        }
        if (this.form.salesDirectToMiscellaneous) {
          table = [...table, ...this.form.serviceRevenue2.map(val => ({ ...val, isOtherRevenue: true }))]
        }

        // let table = this.form.salesDirectToMiscellaneous ? [...this.form.serviceRevenue, ...this.form.serviceRevenue2.map(val => ({ ...val, isOtherRevenue: true }))] : [...this.form.serviceRevenue]
        if (this.form.chargeDirectToNonCostAccount) {
          table = [...table, ...this.form.nonCost.map(val => ({ ...val, isNonCost: true }))]
        }
        if (this.form.typeOfExpenditure === 'isBoth') {
          table = [...table, ...this.form.salesServiceItems]
        }

        // console.log('isWHTaxSwitch', this.form.isWHTaxSwitch)
        // console.log('isVatWHTaxSwitch', this.form.isVatWHTaxSwitch)
        if (!this.form.isVatWHTaxSwitch && this.applyVatWHTaxObj) table.push(this.applyVatWHTaxObj)
        if (!this.form.isWHTaxSwitch && this.applyWHTaxObj) table.push(this.applyWHTaxObj)
        console.log('table', table)
        for (let i = 0; i < table.length; i++) {
          const vatableAmount = await this.countVatableAmount([table[i]], this.form.amountsAre)
          const vatAmount = await this.countWTax(vatableAmount, table[i].taxRate)
          const item = {
            cashDisbursementHeaderId: cashDisbursementHeader.id,
            accountNumber: table[i].no,
            accountId: table[i].revenueAccount,
            details: table[i].description ? table[i].description : null,
            unitPrice: table[i].price,
            unitId: table[i].unit,
            qty: table[i].qty,
            // TODO: add type for table
            typeTable: table[i].typeTable,
            totalAmount: table[i].totalAmount,
            taxCodeId: table[i].isVendorWHTax ? table[i].revenueAccount : table[i].taxCode,
            taxRate: table[i].taxRate,
            vatableAmount,
            vatExemptAmount: this.salesTaxListExemptTax.id === table[i].taxCode ? table[i].totalAmount : 0,
            zeroRatedAmount: this.salesTaxListWithZeroRate.id === table[i].taxCode ? table[i].totalAmount : 0,
            vatAmount: table[i].isVendorWHTax ? vatableAmount : vatAmount,
            notaxAmount: this.salesTaxListNoTaxSP.id === table[i].taxCode ? table[i].totalAmount : 0,
            allocatedTo: table[i].entityTypeId,
            buId: table[i].buId,
            whsengproId: table[i].parentId,
            taskId: table[i].taskId,
            euId: table[i].userId,
            isOtherRevenue: !!table[i].isOtherRevenue,
            isOtherExpenditure: !!table[i].isOtherRevenue,
            isVendorWHTax: !!table[i].isVendorWHTax,
            itemId: table[i].itemId,
            warehouseId: table[i].warehouseId,
            // TODO
            itemNo: null,
            itemName: null,
            discount: null,
            discountAccountId: table[i].discountAccountId,
            isNonCost: !!table[i].isNonCost
          }
          if (this.form.typeOfExpenditure === 'isBuyingItems') {
            const account = this.accountsRevenue.find(val => val.id === table[i].itemId)
            if (account && account.purchaseAccount) {
              item.accountId = account.purchaseAccount.id
              // item.itemId = table[i].revenueAccount
            } else {
              // item.accountId = null
              // item.itemId = table[i].revenueAccount
            }
          }
          if (this.form.typeOfExpenditure === 'isBoth') {
            const account = this.accountsRevenueSales.find(val => val.id === table[i].itemId)
            if (account && account.purchaseAccount) {
              item.accountId = account.purchaseAccount.id
              // item.itemId = table[i].revenueAccount
            } else {
              // item.accountId = null
              // item.itemId = table[i].revenueAccount
            }
          }
          payload.cashDisbursementDetailsList.push(item)
        }

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.post(`/api/v1/cashDisbursementDetail/create?companyId=${this.$route.query.companyId}`, payload)
      } catch (err) {
        console.log(err)
      }
    },
    async reverse() {
      let loader = this.$loading.show();
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.get(`/api/v1/cashDisbursement/reverse?cashDisbursementHeaderId=${this.$route.params.id}&companyId=${this.$route.query.companyId}&transactionNo=${this.transactionNo}`)
        this.notification("Success", "", "success");
        loader.hide()
        await this.init()
      } catch (err) {
        loader.hide()
      }
    },
    openModalHistory() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/cashDisbursement/history?companyId=${this.$route.query.companyId}&transactionId=${this.form.transactionId}`)
          .then(response => {
            console.log('response', response)
            this.$refs.openHistory.openModal()
            this.historyList = response.data.list
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    async createCashDisbursementTransaction(cashDisbursementHeader) {
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        const response = await axios.get(`/api/v1/cashDisbursementTransaction/create?cashDisbursementHeaderId=${cashDisbursementHeader.id}&companyId=${this.$route.query.companyId}`)
        this.form.transactionId = response.data.transactionId
      } catch (err) {
        console.log(err)
      }
    },
    async createFile(cashDisbursementHeader, fileObj) {
      let loader = this.$loading.show();
      try {
        const formData = new FormData();
        formData.append('file', fileObj);
        formData.append('entityId', cashDisbursementHeader.id);
        formData.append('entityTypeId', 81);
        formData.append('oldParentId', null);
        formData.append('taskId', null);
        formData.append('convert', 'false')
        formData.append('historyEntityId', cashDisbursementHeader.id);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData, {'Content-Type': 'multipart/form-data'})
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
    async changeAmountsAre(val) {
      if (val === 1 || val === 4) {
        this.form.serviceRevenue = this.form.serviceRevenue.map(item => ({...item, taxCode: null, taxRate: 0 }))
        this.form.serviceRevenue2 = this.form.serviceRevenue2.map(item => ({...item, taxCode: null, taxRate: 0 }))
        this.form.salesServiceItems = this.form.salesServiceItems.map((item) => ({...item, taxCode: null, taxRate: 0 }))
        this.form.nonCost = this.form.nonCost.map(item => ({...item, taxCode: null, taxRate: 0 }))
      }
      await this.setTaxCodeToTable()
      await this.calculateResults()
    },
    async calculateResults() {
      await this.$nextTick()
      this.results = initResults()

      let discountList, serviceRevenueNotDiscount
      if (this.form.typeOfExpenditure === 'isBuyingItems') {
        discountList = []
        serviceRevenueNotDiscount = this.form.serviceRevenue
      } else {
        discountList = await this.getDiscountList(this.form.serviceRevenue)
        serviceRevenueNotDiscount = await this.getNotDiscountList(this.form.serviceRevenue)
      }

      // let discountList = await this.getDiscountList(this.form.serviceRevenue)
      // let serviceRevenueNotDiscount = await this.getNotDiscountList(this.form.serviceRevenue)

      let table = this.form.salesDirectToMiscellaneous ? [...serviceRevenueNotDiscount, ...this.form.serviceRevenue2] : [...serviceRevenueNotDiscount]
      if (this.form.chargeDirectToNonCostAccount) {
          table = [...table, ...this.form.nonCost]
      }
      if (this.form.typeOfExpenditure === 'isBoth') {
        table = [...table, ...this.form.salesServiceItems]
      }

      let discountTotalTaxAmountFromTable = await this.countTotalTaxAmountTable(discountList, this.form.amountsAre)
      this.results.totalAmountFromTable = await this.countTotalAmountTable(table)
      this.results.totalTaxAmountFromTable = await this.countTotalTaxAmountTable(table, this.form.amountsAre) - discountTotalTaxAmountFromTable

      // this.results.otherExpendituresCharges = await this.countTotalAmountTable(this.form.serviceRevenue2)
      // this.results.nonCostCharges = await this.countTotalAmountTable(this.form.nonCost)

      if (this.form.amountsAre === 3) {
        this.results.otherExpendituresCharges = await this.countVatableAmount(this.form.serviceRevenue2, this.form.amountsAre)
        this.results.nonCostCharges = await this.countVatableAmount(this.form.nonCost, this.form.amountsAre)
      } else {
        this.results.otherExpendituresCharges = await this.countTotalAmountTable(this.form.serviceRevenue2)
        this.results.nonCostCharges = await this.countTotalAmountTable(this.form.nonCost)
      }

      // discount
      this.results.discount = await this.countTotalAmountTable(discountList)
      let discountVatExAmount = await this.countVatExAmount(discountList)
      let discountZeroRatedAmount = await this.countZeroRatedAmount(discountList)
      let discountNoTaxAmount = await this.countNoTaxAmount(discountList)

      if (this.form.amountsAre === 2 || this.form.amountsAre === 3) {
        this.results.vatableAmount = await this.countVatableAmount(table, this.form.amountsAre) - await this.countVatableAmount(discountList, this.form.amountsAre)
      } else {
        this.results.vatableAmount = await this.countVatableAmount(table, this.form.amountsAre)
      }
      // this.results.vatableAmount = await this.countVatableAmount(table, this.form.amountsAre)
      this.results.vatExAmount = await this.countVatExAmount(table) - discountVatExAmount
      this.results.zeroRatedAmount = await this.countZeroRatedAmount(table) - discountZeroRatedAmount
      this.results.noTaxAmount = await this.countNoTaxAmount(table)
      // if (this.form.amountsAre === 2 || this.form.amountsAre === 3) {
      //   this.results.vatableAmount = await this.countVatableAmount(table, this.form.amountsAre)
      // }

      // TODO VAT Amount
      this.results.vatAmount = this.results.totalTaxAmountFromTable

      // TODO Total Amount (VAT Inclusive)
      this.results.totalAmountVatInclusinve = (this.results.vatableAmount + this.results.vatExAmount + this.results.zeroRatedAmount + this.results.vatAmount)

      switch(this.form.modeOfPayment) {
        case 1:
          // TODO Received Amount
          this.results.receivedAmount = await this.countReceivedAmount(this.$refs.singlePM.form.amountPaid)
          break
        case 2:
          // TODO Received Amount
          this.results.receivedAmount = await this.countReceivedAmount(this.$refs.splitPM.form.items.reduce(
              (accumulator, currentValue) => accumulator + currentValue.amountPaid,
              0
          ))
          break
      }

      // TODO No Tax
      // TODO Amount (No Tax)
      if (this.form.amountsAre === 2 || this.form.amountsAre === 3) {
        this.results.amountVatExcluded = this.results.totalAmountVatInclusinve - this.results.vatAmount + this.results.noTaxAmount - discountNoTaxAmount
      } else {
        this.results.amountVatExcluded = this.results.totalAmountFromTable - this.results.discount
      }

      if (this.form.amountsAre === 2 || this.form.amountsAre === 3) {
        this.results.addVatAmount = this.results.vatAmount
      }

      this.results.lessCreditableWithholdingTax = await this.countWTax(this.results.amountVatExcluded, this.form.whtaxExpandedRate)
      // is toggle switch
      if (this.form.isWHTaxSwitch) {
        this.results.lessCreditableWithholdingTax = 0
      }
      if (this.form.amountsAre !== 1) {
        this.results.lessCreditableWithholdingVat = await this.countWTax(this.results.vatableAmount, this.form.vatWhtaxExpandedRate)
      }
      // is toggle switch
      if (this.form.isVatWHTaxSwitch) {
        this.results.lessCreditableWithholdingVat = 0
      }


      // TODO Less: Total Discounts
      this.results.lessTotalDiscounts = (this.results.lineDiscountsOffered + this.results.lumpsumDiscountsOffered + this.results.scPwdDiscount)
      // TODO Amount NET of Discounts
      this.results.amountNetOfDiscounts = this.results.amountVatExcluded - this.results.lessTotalDiscounts
      // TODO Total Amount (No Tax)
      this.results.totalAmountNoTax = this.results.amountNetOfDiscounts + this.results.addVatAmount
      // TODO Amount Owing
      this.results.amountOwing = this.results.totalAmountNoTax - (this.results.lessCreditableWithholdingTax + this.results.lessCreditableWithholdingVat)
      if (this.form.appliedUnderOverPMTBal > 0) {
        this.results.amountOwing = this.results.amountOwing - this.form.appliedUnderOverPMTBal
      }
      // TODO Balance Owing
      this.results.balanceOwing = this.results.amountOwing - this.results.receivedAmount
      if (this.results.balanceOwing > 0) {
        this.results.underPayment = Math.abs(this.results.balanceOwing)
        this.results.overPayment = 0
      } else if (this.results.balanceOwing < 0) {
        this.results.underPayment = 0
        this.results.overPayment = Math.abs(this.results.balanceOwing)
      } else {
        this.results.underPayment = 0
        this.results.overPayment = 0
      }

      if (this.form.currency && this.form.currency !== this.companyLayout.currency.code) {
        this.results.amountOwingVendorCurrency = this.results.amountOwing * this.form.exchangeRate
        this.results.receivedAmountVendorCurrency = this.results.receivedAmount * this.form.exchangeRate
        this.results.balanceOwingVendorCurrency = this.results.balanceOwing * this.form.exchangeRate
        this.results.underPaymentVendorCurrency = this.results.underPayment * this.form.exchangeRate
        this.results.overPaymentVendorCurrency = this.results.overPayment * this.form.exchangeRate
      }

      this.form.modeOfPayment === 2 && this.calculateBalanceToPay()

      if (this.form.applyVatWHTaxObj) {
        this.setApplyVatWHTaxObj()
      } else {
        this.applyVatWHTaxObj = null
      }

      if (this.form.applyWHTaxObj) {
        this.setApplyWHTaxObj()
      } else {
        this.applyWHTaxObj = null
      }
    },
    setApplyVatWHTaxObj() {
      this.applyVatWHTaxObj = {
        no: null,
        revenueAccount: this.form.applyVatWHTaxObj.id,
        description: `Linked tax account of ${this.form.applyVatWHTaxObj.name}`,
        price: 0,
        unit: null,
        qty: 1,
        scpwdDiscountRate: null,
        discountAmount: null,
        isVendorWHTax: true,
        totalAmount: this.results.lessCreditableWithholdingVat,
        taxCode: null,
        taxRate: 0,
        isScPwd: false,
        entityTypeId: null,
        warehouseId: null,
        buId: null,
        parentId: null,
        taskId: null,
        userId: null,
        itemId: null,
        typeTable: null,
        discountAccountId: null,
        // lists
        whList: [],
        buList: [],
        parentList: [],
        taskList: [],
        userList: []
      }
    },
    setApplyWHTaxObj() {
      this.applyWHTaxObj = {
        no: null,
        revenueAccount: this.form.applyWHTaxObj.id,
        description: `Linked tax account of ${this.form.applyWHTaxObj.name}`,
        price: 0,
        unit: null,
        qty: 1,
        scpwdDiscountRate: null,
        discountAmount: null,
        isVendorWHTax: true,
        totalAmount: this.results.lessCreditableWithholdingTax,
        taxCode: null,
        taxRate: 0,
        isScPwd: false,
        entityTypeId: null,
        warehouseId: null,
        buId: null,
        parentId: null,
        taskId: null,
        userId: null,
        itemId: null,
        typeTable: null,
        discountAccountId: null,
        // lists
        whList: [],
        buList: [],
        parentList: [],
        taskList: [],
        userList: []
      }
    },
    countTotalAmountTable(items) {
      return new Promise((resolve) => {
        const amount = items.reduce((accumulator, currentValue) => accumulator + currentValue.totalAmount, 0)
        resolve(amount)
      })
    },
    countTotalTaxAmountTable(items, amountsAre){
      return new Promise((resolve) => {
        let totalTaxAmountFromTable = 0
        switch(amountsAre) {
            // exclude
          case 2:
            for (let i = 0; i < items.length; i++) {
              totalTaxAmountFromTable = totalTaxAmountFromTable + +((+items[i].totalAmount * items[i].taxRate) / 100).toFixed(6)
            }
            break;
            // include
          case 3:
            for (let i = 0; i < items.length; i++) {
              totalTaxAmountFromTable = totalTaxAmountFromTable + +(+items[i].totalAmount / (1 + (items[i].taxRate/100))) * +(items[i].taxRate/100)
              // totalTaxAmountFromTable = totalTaxAmountFromTable + +(+items[i].totalAmount - ((+items[i].totalAmount * 100) / (100 + items[i].taxRate))).toFixed(2)
            }
            break
          default:
            return resolve(0)
        }
        console.log('totalTaxAmountFromTable', totalTaxAmountFromTable)
        resolve(totalTaxAmountFromTable)
      })
    },
    getDiscountList(items) {
      return new Promise((resolve) => {
        const amount = items.filter((item) => {
          let targetItem
          if (this.form.typeOfSale === 'isBoth') {
            let list = [...this.serviceRevenueAccountsList[0].options, ...this.serviceRevenueAccountsList[1].options]
            targetItem = list.find(i => i.id === item.revenueAccount);
          } else {
            targetItem = this.serviceRevenueAccountsList.find(i => i.id === item.revenueAccount);
          }
          // const targetItem = this.serviceRevenueAccountsList.find(i => i.id === item.revenueAccount);
          if (!targetItem) return false
          if (targetItem.accountTypeId === 30) return true
          return false
        });
        resolve(amount)
      })
    },
    getNotDiscountList(items) {
      return new Promise((resolve) => {
        const amount = items.filter((item) => {
          let targetItem
          if (this.form.typeOfSale === 'isBoth') {
            let list = [...this.serviceRevenueAccountsList[0].options, ...this.serviceRevenueAccountsList[1].options]
            targetItem = list.find(i => i.id === item.revenueAccount);
          } else {
            targetItem = this.serviceRevenueAccountsList.find(i => i.id === item.revenueAccount);
          }
          // const targetItem = this.serviceRevenueAccountsList.find(i => i.id === item.revenueAccount);
          if (!targetItem) return false
          if (targetItem.accountTypeId !== 30) return true
          return false
        });
        resolve(amount)
      })
    },
    countLineTotalDiscountTable(items) {
      let discount = 0
      return new Promise((resolve) => {
        items.map(item => {
          console.log('item', item, +item.discountAmount)
          let lineDiscount = 0
          if (item.scpwdDiscountRate === 1) {
            lineDiscount = this.percentage(+item.discountAmount, +item.totalAmount)
          } else if (item.scpwdDiscountRate === 2) {
            lineDiscount = +item.discountAmount
          }
          discount = discount + lineDiscount
        })
        resolve(discount)
      })
    },
    countVatExAmount(items) {
      let vatExAmount = 0
      return new Promise((resolve) => {
        const vatExItems = items.filter(val => val.taxCode === this.salesTaxListExemptTax.id)
        vatExItems.map(item => {
          const vatableExAmountLine = Number((+item.totalAmount / (1 + (+item.taxRate / 100))).toFixed(6))
          vatExAmount = vatExAmount + vatableExAmountLine
        })
        resolve(vatExAmount)
      })
    },
    countZeroRatedAmount(items) {
      let vatExAmount = 0
      return new Promise((resolve) => {
        const vatExItems = items.filter(val => val.taxCode === this.salesTaxListWithZeroRate.id)
        vatExItems.map(item => {
          const vatableExAmountLine = Number((+item.totalAmount / (1 + (+item.taxRate / 100))).toFixed(6))
          vatExAmount = vatExAmount + vatableExAmountLine
        })
        resolve(vatExAmount)
      })
    },
    async countNoTaxAmount(items) {
      let noTaxAmount = 0
      const filteredItems = items.filter(val => this.salesTaxListNoTax.id === val.taxCode || this.salesTaxListNoTaxSP.id === val.taxCode)
      noTaxAmount = await this.countTotalAmountTable(filteredItems)
      return +noTaxAmount
    },
    async countReceivedAmount(amount) {
      if (this.form.paymentCurrency === this.companyLayout.currency.code && this.form.exchangeRate) {
        return +(amount / this.form.exchangeRate)
      }
      return amount
    },
    countVatableAmount(items, amountsAre) {
      console.log('lol items', items)
      let vatableAmount = 0
      return new Promise((resolve) => {
        const filteredItems = items.filter(val => val.taxCode !== this.salesTaxListExemptTax.id && val.taxCode !== this.salesTaxListWithZeroRate.id && val.taxCode !== this.salesTaxListNoTax.id && val.taxCode !== this.salesTaxListNoTaxSP.id)
        console.log('filteredItems', filteredItems)
        switch (amountsAre) {
            // tax including
          case 3:
            filteredItems.map(item => {
              const vatableAmountLine = Number((+item.totalAmount / (1 + (+item.taxRate / 100))))
              vatableAmount = vatableAmount + vatableAmountLine
            })
            break;
            // tax exclusive
          case 2:
            filteredItems.map(item => {
              vatableAmount = vatableAmount + (+item.totalAmount)
            })
            break;

        }
        resolve(vatableAmount)
      })
    },
    countWTax(amount, taxRate) {
      let result = 0
      return new Promise((resolve) => {
        result = amount * (taxRate / 100)
        resolve(result)
      })
    },
    percentage(percent, total) {
      return ((percent/ 100) * total) || 0
    },
    handleFilePreview(e) {
      console.log('handleFile', e)
      const file = e.target.files[0]
      if (file) {
        this.imgPreview = file
        this.imgPreviewSrc = URL.createObjectURL(file)
        this.filesOpened = true
      }

      // let formData = new FormData();
      // formData.append('file', e.target.files[0]);

    },
    initialData() {
      return {
        listCDForUseBalance: null,
        form: {
          paymentCurrency: null,
          typeOfExpenditure: 'changeDirectToCost',
          purchasingCurrency: null,
          transactionId: null,
          // first row
          // col 1
          vendorId: null,
          vendorTin: null,
          typeOfBusiness: null,
          paymentTerms: null,
          serviceVATCode: null,
          productVATCode: null,
          // vendorContactId: null,
          vendorEmail: null,
          currency: null,
          tranDate: null,
          // tranDate: moment().format("MM-DD-YYYY"),
          isWHTaxExpanded: false,
          saleTaxId: null,
          applyWHTaxObj: null,
          whtaxExpandedRate: 0,
          isVatWHTaxExapnded: false,
          isWHTaxSwitch: false,
          isVatWHTaxSwitch: false,
          veResult: 0,
          veResultAfterRate: 0,
          cashAdvancesToBalance: 0,
          applyVatWHTaxObj: null,
          vatWhtaxExpandedRate: 0,
          addedBy: null,
          forUser: null,
          // row 1
          isUseBalance: false,
          appliedUnderOverPMTBal: 0,
          // col 2
          modeOfPayment: 1,
          paidBy: null,
          // second row
          paymentFor: '',
          typeOfSale: 'isCostService',
          purchasingNotes: null,
          lumpsumDiscountRate: null,
          lumpsumDiscountAmount: null,
          addBillableTime: false,
          addBillableExpenses: false,
          allowDiscounts: 'noDiscount',
          amountsAre: 2,
          exchangeRate: 1,
          // table
          serviceRevenue: [
            {
              no: null,
              revenueAccount: null,
              description: null,
              price: 0,
              unit: null,
              qty: 1,
              scpwdDiscountRate: null,
              discountAmount: null,
              isVendorWHTax: false,
              totalAmount: 0,
              taxCode: null,
              taxRate: 0,
              isScPwd: false,
              entityTypeId: null,
              warehouseId: null,
              buId: null,
              parentId: null,
              taskId: null,
              userId: null,
              // lists
              whList: [],
              buList: [],
              parentList: [],
              taskList: [],
              userList: [],
              itemId: null,
              entityTypeList: [
                { id: 2, name: 'Business Unit' },
                { id: 4, name: 'Warehouse' },
                { id: 3, name: 'Engagement' },
                { id: 1, name: 'Project' },
              ],
              typeTable: 'serviceRevenue',
              discountAccountId: null,
            }
          ],
          serviceRevenue2: [
            {
              no: null,
              revenueAccount: null,
              description: null,
              price: 0,
              unit: null,
              qty: 1,
              scpwdDiscountRate: null,
              discountAmount: null,
              isVendorWHTax: false,
              totalAmount: 0,
              taxCode: null,
              taxRate: 0,
              isScPwd: false,
              entityTypeId: null,
              buId: null,
              warehouseId: null,
              parentId: null,
              taskId: null,
              userId: null,
              // lists
              whList: [],
              buList: [],
              parentList: [],
              taskList: [],
              userList: [],
              itemId: null,
              entityTypeList: [
                { id: 2, name: 'Business Unit' },
                { id: 4, name: 'Warehouse' },
                { id: 3, name: 'Engagement' },
                { id: 1, name: 'Project' },
              ],
              typeTable: 'serviceRevenue2',
              discountAccountId: null,
            }
          ],
          nonCost: [
            {
              no: null,
              revenueAccount: null,
              description: null,
              price: 0,
              unit: null,
              qty: 1,
              scpwdDiscountRate: null,
              discountAmount: null,
              isVendorWHTax: false,
              totalAmount: 0,
              taxCode: null,
              taxRate: 0,
              isScPwd: false,
              entityTypeId: null,
              buId: null,
              warehouseId: null,
              parentId: null,
              taskId: null,
              userId: null,
              // lists
              whList: [],
              buList: [],
              parentList: [],
              taskList: [],
              userList: [],
              itemId: null,
              entityTypeList: [
                { id: 2, name: 'Business Unit' },
                { id: 4, name: 'Warehouse' },
                { id: 3, name: 'Engagement' },
                { id: 1, name: 'Project' },
              ],
              typeTable: 'nonCost',
              discountAccountId: null,
            }
          ],
          salesServiceItems: [
            {
              no: null,
              revenueAccount: null,
              description: null,
              price: 0,
              unit: null,
              qty: 1,
              scpwdDiscountRate: null,
              discountAmount: null,
              isVendorWHTax: false,
              totalAmount: 0,
              taxCode: null,
              taxRate: 0,
              isScPwd: false,
              entityTypeId: null,
              buId: null,
              warehouseId: null,
              parentId: null,
              taskId: null,
              userId: null,
              // lists
              whList: [],
              buList: [],
              parentList: [],
              taskList: [],
              userList: [],
              itemId: null,
              entityTypeList: [
                { id: 2, name: 'Business Unit' },
                { id: 4, name: 'Warehouse' },
                { id: 3, name: 'Engagement' },
                { id: 1, name: 'Project' },
              ],
              typeTable: 'salesServiceItems',
              discountAccountId: null,
            }
          ],
          generalSwitch: true,
          salesDirectToMiscellaneous: false,
          chargeDirectToNonCostAccount: false,
          cashAdvancesToBalanceDetails: 0,
          // isUseBalance: false,
          // third row
          template: null,
          officialDisbursementNumber: 1,
          issueDate: null,
          receiptAdvice: null,
          createByFullName: '',
          paidDate: null,
        },
        rules: {
          paymentCurrency: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          typeOfExpenditure: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          vendorId: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          // vendorContactId: [{
          //   required: true,
          //   message: this.$i18n.t('modal_settings_fieldIsRequired'),
          //   trigger: 'change'
          // }],
          paidBy: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          exchangeRate: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          forUser: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          purchasingNotes: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          paymentFor: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          template: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          officialDisbursementNumber: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          issueDate: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          tranDate: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
          paidDate: [{
            required: true,
            message: this.$i18n.t('modal_settings_fieldIsRequired'),
            trigger: 'change'
          }],
        },
        modeOfPaymentList: [
          { id: 1, name: 'Single Payment (default)' },
          { id: 2, name: 'Split Payment' },
          // { id: 3, name: 'Use A Clearing Account' },
          // { id: 4, name: 'Receive Post Dated Cheques' },
        ],
        vendorList: [],
        forUserList: [],
        paymentMethodList: [],
        depositAccountList: [],
        salesTaxList: [],
        templateList: [
          { id: 1, name: 'Template 1' }
        ],
        results: initResults(),
        // table list
        accountsExpenses: [],
        accountsCostOFService: [],
        accountsRevenue: [],
        accountsRevenueSales: [],
        accountsAll: [],
        accountsMiscellaneousIncome: [],
        accountsOtherExpenditures: [],
        units: [],
        money: {
          precision: 2,
          decimal: '.',
          thousands: ',',
        },
        moneyDr: {
          precision: 2,
          decimal: '.',
          thousands: ',',
          suffix: ' Dr',
          masked: false
        },
        lumpsumDiscountRates: [
          { id: 1 , name: 'Percentage (%)' },
          { id: 2 , name: 'Amount ($)' }
        ],
        entityTypeList: [
          { id: 2, name: 'Business Unit' },
          { id: 4, name: 'Warehouse', disabled: true },
          { id: 3, name: 'Engagement' },
          { id: 1, name: 'Project' },
        ],
        taxList: [
          {id: 1, name: 'No Tax'},
          {id: 2, name: 'Excluding Tax'},
          {id: 3, name: 'Including Tax'},
          {id: 4, name: 'Tax Exempt'},
        ],
        moment: moment,
        transaction: {},
        transactionNo: null,
        status: null,
        isBlock: false,
        disabledForm: false,
        updatedState: false,
        historyList: [],
        applyVatWHTaxObj: null,
        applyWHTaxObj: null,
        typeOfExpenditureList: [
          { id: 'changeDirectToCost', name: 'Change Direct to Cost or Expense Account' },
          { id: 'isBuyingItems', name: 'Buying of Items' },
          { id: 'isBoth', name: 'Both' }
        ],
        filesOpened: false,
        imgPreviewSrc: null,
        imgPreview: null,
        isSendToAcc: false,
        vendorDirectories: null
      }
    },
    changeTypeOfExpenditureConfirm(val) {
      this.$confirm('If You change Type of Sale, all any entered will be removed. Client details will not be effected', 'Warning', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'info'
      }).then(async () => {
        let loader = this.$loading.show();
        try {
          this.form.typeOfSale = 'isCostService'
          this.form.typeOfExpenditure = val
          this.form.serviceRevenue = this.initialData().form.serviceRevenue
          this.form.serviceRevenue2 = this.initialData().form.serviceRevenue2
          await this.changeTypeOfExpenditure(val)
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }

      })
    },
    async changeTypeOfExpenditure(val) {
      this.form.serviceRevenue = this.form.serviceRevenue.map(val => ({...val, revenueAccount: null }))
      this.form.serviceRevenue2 = this.form.serviceRevenue2.map(val => ({...val, revenueAccount: null }))

      let loader = this.$loading.show();
      switch (val) {
        // case 'isSDtoSRA':
        //   try {
        //     const response = await axios.get(`/api/v1/cashReceipt/directories?companyId=${this.$route.query.companyId}&countryId=${this.companyLayout.countryId}`)
        //     this.accountsRevenue = response.data.directories.accountsRevenue
        //     this.accountsMiscellaneousIncome = response.data.directories.accountsMiscellaneousIncome
        //     loader.hide()
        //   } catch (err) {
        //     loader.hide()
        //     console.log(err)
        //   }
        //   break
        case 'isBuyingItems':
          try {
            const response = await axios.get(`/api/v1/items/active-list?companyId=${this.$route.query.companyId}`)
            this.accountsRevenue = response.data.list.filter(val => val.purchase)
            loader.hide()
          } catch (err) {
            loader.hide()
            console.log(err)
          }
          break
        case 'isBoth':
          try {
            const response = await axios.get(`/api/v1/items/active-list?companyId=${this.$route.query.companyId}`)
            this.accountsRevenueSales = response.data.list.filter(val => val.purchase)
            const response2 = await axios.get(`/api/v1/cashDisbursement/directories?companyId=${this.$route.query.companyId}&countryId=${this.companyLayout.countryId}`)
            // this.accountsRevenue = response2.data.directories.accountsRevenue
            this.accountsRevenue = response2.data.directories.accountsCostOFService
            this.accountsMiscellaneousIncome = response2.data.directories.accountsMiscellaneousIncome
            loader.hide()
          } catch (err) {
            loader.hide()
            console.log(err)
          }
          break
        default:
          try {
            const response = await axios.get(`/api/v1/cashDisbursement/directories?companyId=${this.$route.query.companyId}&countryId=${this.companyLayout.countryId}`)
            this.accountsRevenue = response.data.directories.accountsRevenue
            this.accountsMiscellaneousIncome = response.data.directories.accountsMiscellaneousIncome
            loader.hide()
          } catch (err) {
            loader.hide()
            console.log(err)
          }
      }
    },
    changeTypeOfSale() {
      this.form.serviceRevenue = this.form.serviceRevenue.map(val => ({...val, revenueAccount: null, no: null }))
      this.form.serviceRevenue2 = this.form.serviceRevenue2.map(val => ({...val, revenueAccount: null, no: null }))
    },
    addVendorOpenModal() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/client-vendor/directories?companyId=${this.$route.query.companyId}&type=vendor&countryId=${this.companyLayout.countryId}`)
          .then(response => {
            console.log('client-vendor/directories', response.data);
            this.vendorDirectories = response.data.list
            this.$refs['modal11'].openModal()

            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
    },
    async selectVendor(id) {
      try {
        this.form.vendorId = id
        await this.directories()
        await this.changeVendor(id)
      } catch (err) {
        console.log(err)
      }
    },
    appliedUnderOverPMTChange(e){
      console.log('====____', e)
      if ((this.form.appliedUnderOverPMTBal > this.form.veResult) && this.form.isUseBalance) {
        this.form.appliedUnderOverPMTBal = this.form.veResult
      }
      this.calculateResults()
    },
    openJournalModal() {
      const rowItem = {...this.transaction}
      this.$refs['editJournalEntryModal'].openModalFromJournalEntry(rowItem)
    }
  },
  watch: {
    'form.serviceRevenue': {
      handler() {
        this.calculateResults()
      },
      deep: true
    },
    'form.serviceRevenue2': {
      handler() {
        this.calculateResults()
      },
      deep: true
    },
    'form.nonCost': {
      handler() {
        this.calculateResults()
      },
      deep: true
    },
    'form.salesServiceItems': {
      handler() {
        this.calculateResults()
      },
      deep: true
    },
    '$route'(){
      // this.paymentMethodList = []
      // this.$refs.form.resetFields()
      // Object.assign(this.$data, this.initialData())
      // this.init()

      this.paymentMethodList = []
      Object.assign(this.$data, this.initialData())
      this.$refs['crServiceRevenue'].$refs['form'].resetFields()
      this.$nextTick(() => {
        if (this.$refs['crServiceRevenue']) this.$refs['crServiceRevenue'].$refs['form'].resetFields()
        if (this.$refs['crServiceRevenue2']) this.$refs['crServiceRevenue2'].$refs['form'].resetFields()
        if (this.$refs['cdNonCost']) this.$refs['cdNonCost'].$refs['form'].resetFields()
        if (this.$refs['singlePM']) this.$refs['singlePM'].$refs['form'].resetFields()
        if (this.$refs['splitPM']) this.$refs['splitPM'].$refs['form'].resetFields()
        this.$refs['form'].resetFields()
        this.init()
      })
    }
  }
}

const initResults = () => {
  return {
    // first column
    lineDiscountsOffered: 0, // TODO No Tax
    lumpsumDiscountsOffered: 0, // TODO No Tax
    scPwdDiscount: 0, // TODO No Tax
    otherExpendituresCharges: 0, // TODO No Tax
    nonCostCharges: 0, // TODO No Tax
    discount: 0,
    vatableAmount: 0, // TODO No Tax
    vatExAmount: 0, // TODO Tax Exempt
    zeroRatedAmount: 0, // TODO No Tax
    noTaxAmount: 0,
    vatAmount: 0, // TODO No Tax
    addVat: 0,
    totalAmount: 0,
    // second column
    amountVatExcluded: 0, // TODO No Tax
    lessTotalDiscounts: 0, // TODO No Tax
    amountNetOfDiscounts: 0, //TODO No Tax
    totalAmountNoTax: 0, //TODO No Tax
    lessCreditableWithholdingVat: 0, // TODO Tax Exempt
    lessCreditableWithholdingTax: 0, //TODO No Tax
    lessSCPWDDiscount: 0,
    addVatAmount: 0, //TODO No Tax
    totalAmountVatInclusinve: 0, //TODo No Tax
    amountNetVat: 0,
    lessWHTaxExpanded: 0,
    lessVatWHTaxExpanded: 0,
    amountOwing: 0, //TODO No Tax
    receivedAmount: 0, // TODO No Tax
    balanceOwing: 0, // TODO No Tax
    overPayment: 0,
    underPayment: 0,
    // third column
    amountOwingVendorCurrency: 0,
    receivedAmountVendorCurrency: 0,
    balanceOwingVendorCurrency: 0,
    underPaymentVendorCurrency: 0,
    overPaymentVendorCurrency: 0,
    // hidden results
    totalAmountFromTable: 0,
    totalTaxAmountFromTable: 0,
    totalDiscountFromTable: 0,
    nonCost: 0,
  }
}
</script>

<style lang="scss" scoped>
.checkbox__title {
  display: inline-block;
  width: 18px;
  margin-left: 10px;
  font-weight: bold;
  color: #F56C6C;
  &_yes {
    color: #67C23A;
  }
}

.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;

  .wrapper {
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;

    .main-wrap {
      padding: 20px;
      width: 100%;

      .settings-header {
        text-align: left;
        justify-content: space-between;
        display: flex;
        .tf-link {
          font-weight: 400;
          color: #409EFF;
          font-size: 16px;
        }
      }
      .select {
        width: 100%;
      }
      .form {
        display: flex;
        flex-direction: column;
        gap: 30px;
        .card {
          position: relative;
          .right-corner {
            position: absolute;
            top: 10px;
            right: 10px;
            display: flex;
            gap: 20px;
            &__badge {
              border: 1px solid black;
              padding: 10px 20px;
            }
          }
          .t-title {
            margin-bottom: 10px;
          }
          .radio-group-col {
            display: flex;
            gap: 5px;
            flex-direction: column;
          }
          &.card-2 {
            .t-textarea {
              /deep/ textarea {
                max-width: 500px;
                width: 100%;
              }
            }
            .t-switch {
              width: 200px;
              display: flex;
              justify-content: space-between;
            }
          }
          &.card-3 {
            .price-wrapper {
              display: flex;
              align-items: flex-end;
              justify-content: flex-end;
              width: fit-content;
              gap: 20px;
              float: right;
              .item {
                font-size: 14px;
                display: flex;
                justify-content: space-between;
                min-width: 260px;
                padding: 6px;
                margin-bottom: 10px;
                border: 1px solid #a9a9b0;
                &.orange {
                  background-color: #f5dab1;
                  width: 220px;
                  min-width: 220px;
                  margin-left: auto;
                }
                &.success {
                  background-color: #e1f3d8;
                }
                &.grey {
                  background-color: #ebeef5;
                }
                &.bold {
                  font-weight: bold;
                }
                &.dots {
                  border: 1px dashed #a9a9b0;
                }
                &.prices {
                  align-items: center;
                  justify-content: center;
                  text-align: center;
                  min-width: 100px;
                }
              }
            }
          }
          .transaction-no {
            font-weight: bold;
            color: rgb(64, 158, 255);
            cursor: pointer;
            // &:hover {
            //   text-decoration: underline;
            // }
          }
        }
        .source-wrapper {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .source {
            display: flex;
            gap: 30px;
            align-items: center;
          }
          .tf-icon {
            font-size: 24px;
            cursor: pointer;
          }
        }
      }
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
.payment-data {
  margin-top: 150px;
}

/deep/.v-money {
  height: 28px;
  line-height: 28px;
  -webkit-appearance: none;
  background-color: transparent;
  background-image: none;
  border: none;
  border-bottom: 2px solid #DCDFE6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  outline: 0;
  padding: 0 15px 0 0;
  -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
  width: 100%;
}

/deep/.el-form-item__label:before {
  display: none;
}
</style>

<style lang="scss">
.el-date-editor.el-input {
  width: 100%;
}
</style>